angular.module('controllers')
        .controller('crudController', ['$scope', '$rootScope', 'Crud', '$mdDialog', '$filter', 'orderByFilter', '$route', '$routeParams', '$location', '$timeout', '$interval', '$window',
            function ($scope, $rootScope, Crud, $mdDialog, $filter, orderByFilter, $route, $routeParams, $location, $timeout, $interval, $window) {

                $rootScope.$on('$locationChangeSuccess', function () {
                    $interval.cancel($rootScope.stopTimer);
                    $interval.cancel($rootScope.stopTimerOrder);
                    $interval.cancel($rootScope.stopTimerSlot);
                    $interval.cancel($rootScope.stopCheckOn);
                });

                $rootScope.checkNetworkConnection = function () {
                    /*if (angular.isUndefined($rootScope.networkConnection)) {
                     $rootScope.networkConnection = true;
                     }
                     $scope.$watch('networkConnection', function () {
                     console.log($rootScope.networkConnection);
                     if ($rootScope.networkConnection == false) {*/
                    $mdDialog.show(
                            $mdDialog.alert()
                            .parent(angular.element(document.querySelector('#popupContainer')))
                            .clickOutsideToClose(true)
                            .title('Deconectare server')
                            .textContent('Verificati conexiunea de internet')
                            .ariaLabel('Network connection')
                            .ok('Renunta')
                            );
                    /* }
                     }, true);*/
                }

                if (angular.isUndefined(localStorage.getItem('log')) || localStorage.getItem('log') == null) {
                    window.location.href = '/';
                    localStorage.setItem('log', 1);
                }

                var widthContentBar = $('#content').width();
                if (widthContentBar <= '500') {
                    $('#content .wrap-card').addClass('m500');
                } else {
                    $('#content .wrap-card').removeClass('m500');
                }

                $scope.path = $rootScope.path;
                $scope.model = $rootScope.model;
                $scope.modelData = {};
                $scope.filters = {};
                $scope.sortReverse = false;

                $scope.state = {};
                $scope.state.searchCrud = '';

                $scope.mode_action_options = [
                    {'id': 'page', 'value': 'In pagina', 'fa': 'fa-file-o'},
                    {'id': 'dialog', 'value': 'In dialog', 'fa': 'fa-file-powerpoint-o'}
                ];

                $timeout(function () {
                    var heightTableForTotal = angular.element(document.querySelector('.table')).height() + 1;
                    $('<style>.header th.total::after{height: ' + heightTableForTotal + 'px;}</style>').appendTo('head');
                }, 5000);
                $scope.hoverColumn = function (cardId) {
                    if (!angular.isUndefined(cardId)) {
                        var heightTable = angular.element(document.querySelector('#' + cardId + ' .table')).height() + 1;
                    } else {
                        var heightTable = angular.element(document.querySelector('.table')).height() + 1;
                    }
                    $('<style>.header th:hover::after{height: ' + heightTable + 'px;}</style>').appendTo('head');
                }

                /* export table on csv */
                $scope.exportDataCsv = function (models, availableColumns, columns) {

                    $scope.exportModels = [];
                    models = $filter('filter')(models, $scope.filterColumn);
                    if (!angular.isUndefined($scope.state.searchCrud) && $scope.state.searchCrud != '') {
                        models = $filter('filter')(models, function (item, keyItem) {
                            var ctrl = [];
                            ctrl[keyItem] = {};
                            angular.forEach($scope[columns], function (itemColumns, keyColumns) {
                                if (itemColumns.associate == 1) {
                                    if (String(item[itemColumns.relation][itemColumns.colRelation]).indexOf($scope.state.searchCrud) >= 0) {
                                        ctrl[keyItem][0] = 1;
                                    }
                                    if (!angular.isUndefined(columns.options)) {
                                        var position = columns.options.map(function (e) {
                                            return e[$rootScope.typeId];
                                        }).indexOf(id);

                                        if (!angular.isUndefined(columns.options[position])) {
                                            ctrl[keyItem][0] = 1;
                                        }
                                    }
                                } else {
                                    if (String(item[keyColumns]).indexOf($scope.state.searchCrud) >= 0) {
                                        ctrl[keyItem][0] = 1;
                                    }
                                }
                            });

                            if (ctrl[keyItem][0] == 1) {
                                return item;
                            }
                        });
                    }
                    angular.forEach(models, function (item, index) {
                        var object = {};
                        if (angular.isUndefined(availableColumns) || availableColumns.length == 0) {
                            angular.forEach($scope[columns], function (itemColumns, keyColumns) {
                                if (itemColumns.associate == 1) {
                                    if (item[itemColumns.relation] != null) {
                                        if (item[itemColumns.relation][itemColumns.colRelation] instanceof Array) {
                                            object[keyColumns] = '';
                                        } else {
                                            object[keyColumns] = item[itemColumns.relation][itemColumns.colRelation];
                                        }
                                    } else {
                                        if (!angular.isUndefined($scope[columns][keyColumns].options)) {
                                            var position = $scope[columns][keyColumns].options.map(function (e) {
                                                return e[$rootScope.typeId];
                                            }).indexOf(item[keyColumns]);
                                            if (!angular.isUndefined($scope[columns][keyColumns].options[position])) {
                                                if ($scope[columns][keyColumns].options[position].value instanceof Array) {
                                                    object[keyColumns] = '';
                                                } else {
                                                    object[keyColumns] = $scope[columns][keyColumns].options[position].value;
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    if (item[keyColumns] instanceof Array) {
                                        object[keyColumns] = '';
                                    } else {
                                        if ($scope[columns][keyColumns]['filterType'] == 'select') {
                                            if (!angular.isUndefined(item[keyColumns]) && item[keyColumns] !== '') {
                                                object[keyColumns] = $scope.additionals['associativeColumn']($scope[columns][keyColumns], item[keyColumns]);
                                            }
                                        } else {
                                            object[keyColumns] = item[keyColumns];
                                        }
                                        if (keyColumns == 'average_delivery_time' || keyColumns == 'value_delivery_time_grouped') {
                                            object[keyColumns] = $scope.additionals['formatTime'](item[keyColumns]);
                                        }

                                    }
                                }

                                if (keyColumns == 'cost_cashing_type') {
                                    object[keyColumns] = '';
                                    angular.forEach(item['costs'], function (itemCost, indexCost) {
                                        if (!angular.isUndefined(itemCost)) {
                                            object[keyColumns] = object[keyColumns] + ' cheltuiala suplimentara \n';
                                        }
                                    });
                                    angular.forEach(item['cashings'], function (itemCashing, indexCashing) {
                                        if (!angular.isUndefined(itemCashing)) {
                                            object[keyColumns] = object[keyColumns] + ' incasare suplimentara \n';
                                        }
                                    });
                                }
                                if (keyColumns == 'cost_cashing_value') {
                                    object[keyColumns] = '';
                                    angular.forEach(item['costs'], function (itemCost, indexCost) {
                                        if (!angular.isUndefined(itemCost)) {
                                            if (!angular.isUndefined(itemCost['cost_value'])) {
                                                object[keyColumns] = object[keyColumns] + '' + itemCost['cost_value'] + '\n';
                                            }
                                        }
                                    });
                                    angular.forEach(item['cashings'], function (itemCashing, indexCashing) {
                                        if (!angular.isUndefined(itemCashing)) {
                                            if (!angular.isUndefined(itemCashing['cashing_value'])) {
                                                object[keyColumns] = object[keyColumns] + '' + itemCashing['cashing_value'] + '\n';
                                            }
                                        }
                                    });
                                }
                                if (keyColumns == 'cost_cashing_reason') {
                                    object[keyColumns] = '';
                                    angular.forEach(item['costs'], function (itemCost, indexCost) {
                                        if (!angular.isUndefined(itemCost)) {
                                            if (!angular.isUndefined(itemCost['cost_reason'])) {
                                                object[keyColumns] = object[keyColumns] + '' + itemCost['cost_reason'] + '\n';
                                            }
                                        }
                                    });
                                    angular.forEach(item['cashings'], function (itemCashing, indexCashing) {
                                        if (!angular.isUndefined(itemCashing)) {
                                            if (!angular.isUndefined(itemCashing['cashing_reason'])) {
                                                object[keyColumns] = object[keyColumns] + '' + itemCashing['cashing_reason'] + '\n';
                                            }
                                        }
                                    });
                                }
                                if (keyColumns == 'drivers') {
                                    object[keyColumns] = '';
                                    angular.forEach(item['drivers'], function (itemDriver, indexDriver) {
                                        if (!angular.isUndefined(itemDriver)) {
                                            if (!angular.isUndefined(itemDriver['driver_name'])) {
                                                object[keyColumns] = object[keyColumns] + '' + itemDriver['driver_name'] + '\n';
                                            }
                                        }
                                    });
                                }
                                if (keyColumns == 'order_incidents') {
                                    object[keyColumns] = '';
                                    angular.forEach(item['order_incidents'], function (itemIncident, indexIncident) {
                                        if (!angular.isUndefined(itemIncident)) {

                                            var indexIncidents = indexIncident + 1;
                                            if (itemIncident['food_product_id'] == 0) {
                                                object[keyColumns] = object[keyColumns] + indexIncidents + '.' + itemIncident['order_incident'] + '\n\n';
                                            }
                                            if (itemIncident['food_product_id'] != 0) {
                                                object[keyColumns] = object[keyColumns] + indexIncidents + '.' + itemIncident['food_product_name'] + ' (' + itemIncident['food_product_code'] + ') :' + itemIncident['food_product_quantity'] + ' buc - ' + itemIncident['food_product_incident'] + '\n\n';
                                            }

                                        }
                                    });
                                }

                                if (keyColumns == 'department_incidents') {
                                    object[keyColumns] = '';
                                    angular.forEach(item['order_incidents'], function (itemIncident, indexIncident) {
                                        if (!angular.isUndefined(itemIncident)) {
                                            var indexIncidents = indexIncident + 1;
                                            object[keyColumns] = object[keyColumns] + $scope.additionals['associativeColumn']($scope.additionals['incident_department'], itemIncident['department_incident']) + '\n\n';
                                        }
                                    });
                                }
                                $scope.exportModels[index] = object;
                            });
                        } else {
                            angular.forEach(availableColumns, function (itemColumns) {
                                if (!angular.isUndefined($scope[columns][itemColumns])) {
                                    if ($scope[columns][itemColumns].associate == 1) {
                                        if (item[$scope[columns][itemColumns].relation] != null) {
                                            if (tem[$scope[columns][itemColumns].relation][$scope[columns][itemColumns].colRelation] instanceof Array) {
                                                object[itemColumns] = '';
                                            } else {
                                                object[itemColumns] = item[$scope[columns][itemColumns].relation][$scope[columns][itemColumns].colRelation];
                                            }
                                        } else {
                                            if (!angular.isUndefined($scope[columns][itemColumns].options)) {
                                                var position = $scope[columns][itemColumns].options.map(function (e) {
                                                    return e[$rootScope.typeId];
                                                }).indexOf(item[itemColumns]);
                                                if (!angular.isUndefined($scope[columns][itemColumns].options[position])) {
                                                    if ($scope[columns][itemColumns].options[position].value instanceof Array) {
                                                        object[itemColumns] = '';
                                                    } else {
                                                        object[itemColumns] = $scope[columns][itemColumns].options[position].value;
                                                    }
                                                }
                                            }
                                        }
                                    } else {
                                        if (item[itemColumns] instanceof Array) {
                                            object[itemColumns] = '';
                                        } else {
                                            if ($scope[columns][itemColumns]['filterType'] == 'select') {
                                                if (!angular.isUndefined(item[itemColumns]) && item[itemColumns] !== '') {
                                                    object[itemColumns] = $scope.additionals['associativeColumn']($scope[columns][itemColumns], item[itemColumns]);
                                                }
                                            } else {
                                                object[itemColumns] = item[itemColumns];
                                            }
                                            if (itemColumns == 'average_delivery_time' || itemColumns == 'value_delivery_time_grouped') {
                                                object[itemColumns] = $scope.additionals['formatTime'](item[itemColumns]);
                                            }
                                        }
                                    }
                                }
                                if (itemColumns == 'cost_cashing_type') {
                                    object[itemColumns] = '';
                                    angular.forEach(item['costs'], function (itemCost, indexCost) {
                                        if (!angular.isUndefined(itemCost)) {
                                            object[itemColumns] = object[itemColumns] + ' cheltuiala suplimentara \n';

                                        }
                                    });
                                    angular.forEach(item['cashings'], function (itemCashing, indexCashing) {
                                        if (!angular.isUndefined(itemCashing)) {
                                            object[itemColumns] = object[itemColumns] + ' incasare suplimentara \n';
                                        }
                                    });
                                }
                                if (itemColumns == 'cost_cashing_value') {
                                    object[itemColumns] = '';
                                    angular.forEach(item['costs'], function (itemCost, indexCost) {
                                        if (!angular.isUndefined(itemCost)) {
                                            if (!angular.isUndefined(itemCost['cost_value'])) {
                                                object[itemColumns] = object[itemColumns] + '' + itemCost['cost_value'] + '\n';
                                            }
                                        }
                                    });
                                    angular.forEach(item['cashings'], function (itemCashing, indexCashing) {
                                        if (!angular.isUndefined(itemCashing)) {
                                            if (!angular.isUndefined(itemCashing['cashing_value'])) {
                                                object[itemColumns] = object[itemColumns] + '' + itemCashing['cashing_value'] + '\n';
                                            }
                                        }
                                    });
                                }
                                if (itemColumns == 'cost_cashing_reason') {
                                    object[itemColumns] = '';
                                    angular.forEach(item['costs'], function (itemCost, indexCost) {
                                        if (!angular.isUndefined(itemCost)) {
                                            if (!angular.isUndefined(itemCost['cost_reason'])) {
                                                object[itemColumns] = object[itemColumns] + '' + itemCost['cost_reason'] + '\n';
                                            }
                                        }
                                    });
                                    angular.forEach(item['cashings'], function (itemCashing, indexCashing) {
                                        if (!angular.isUndefined(itemCashing)) {
                                            if (!angular.isUndefined(itemCashing['cashing_reason'])) {
                                                object[itemColumns] = object[itemColumns] + '' + itemCashing['cashing_reason'] + '\n';
                                            }
                                        }
                                    });
                                }
                                if (itemColumns == 'drivers') {
                                    object[itemColumns] = '';
                                    angular.forEach(item['drivers'], function (itemDriver, indexDriver) {
                                        if (!angular.isUndefined(itemDriver)) {
                                            if (!angular.isUndefined(itemDriver['driver_name'])) {
                                                object[itemColumns] = object[itemColumns] + '' + itemDriver['driver_name'] + '\n';
                                            }
                                        }
                                    });
                                }
                                if (itemColumns == 'order_incidents') {
                                    object[itemColumns] = '';
                                    angular.forEach(item['order_incidents'], function (itemIncident, indexIncident) {
                                        if (!angular.isUndefined(itemIncident)) {

                                            var indexIncidents = indexIncident + 1;

                                            if (itemIncident['food_product_id'] == 0) {
                                                object[itemColumns] = object[itemColumns] + indexIncidents + '.' + itemIncident['order_incident'] + '\n\n';
                                            }
                                            if (itemIncident['food_product_id'] != 0) {
                                                object[itemColumns] = object[itemColumns] + indexIncidents + '.' + itemIncident['food_product_name'] + ' (' + itemIncident['food_product_code'] + ') :' + itemIncident['food_product_quantity'] + ' buc - ' + itemIncident['food_product_incident'] + '\n\n';
                                            }
                                        }
                                    });
                                }
                                if (itemColumns == 'department_incidents') {
                                    object[itemColumns] = '';
                                    angular.forEach(item['order_incidents'], function (itemIncident, indexIncident) {
                                        if (!angular.isUndefined(itemIncident)) {

                                            var indexIncidents = indexIncident + 1;

                                            object[itemColumns] = object[itemColumns] + $scope.additionals['associativeColumn']($scope.additionals['incident_department'], itemIncident['department_incident']) + '\n\n';

                                        }
                                    });
                                }
                                $scope.exportModels[index] = object;
                            });
                        }
                    });
                    return $scope.exportModels;
                };

                $scope.exportHeader = function (columns, availableColumns) {
                    $scope.exportColumns = [];
                    if (angular.isUndefined(availableColumns) || availableColumns.length == 0) {
                        angular.forEach(columns, function (item, index) {
                            $scope.exportColumns.push(item.label);
                        });
                    } else {
                        angular.forEach(availableColumns, function (item, index) {
                            if (!angular.isUndefined(columns[item])) {
                                $scope.exportColumns.push(columns[item].label);
                            }
                        });
                    }
                    return $scope.exportColumns;
                };
                $scope.exportSeparator = ',';
                $scope.exportDecimalSeparator = '.';

                /* export table on xls*/
                $scope.fileName = $scope.modelName.replace(' ', '_');
                /*$scope.exportXlsData = function (models) {
                 var blob = new Blob([
                 new Uint8Array([0xEF, 0xBB, 0xBF]),
                 /!* angular.element(document.querySelector('div#container-table')).html()*!/
                 $('div#container-table:not(\'tr .filter\')').html()
                 ], {
                 type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8 bom'
                 });
                 saveAs(blob, $scope.modelName.replace(' ', '_') + '.xls');
                 };*/

                $scope.sortColumns = function (type, columns, models) {
                    if ($scope[columns][type].associate == 1) {
                        $scope.sortType = $scope[columns][type].relation + '.' + $scope[columns][type]['colRelation'];
                    } else {
                        $scope.sortType = type;
                    }
                    $scope.sortReverse = !$scope.sortReverse;
                    $scope[models] = orderByFilter($scope[models], $scope.sortType, $scope.sortReverse);
                };

                $scope.searchCrudTable = function (columns) {
                    return function (model) {
                        var controls = 0;
                        angular.forEach($scope[columns], function (itemColumns, keyColumns) {
                            if ($scope[columns][keyColumns].filterType == 'select') {
                                if ($scope[columns][keyColumns].associate == 1) {
                                    if (!angular.isUndefined(model[$scope[columns][keyColumns].relation]) && model[$scope[columns][keyColumns].relation] != null) {
                                        var object = model[$scope[columns][keyColumns].relation][$scope[columns][keyColumns].colRelation];
                                    }
                                } else {
                                    if (!angular.isUndefined($scope[columns][keyColumns].options)) {
                                        var position = $scope[columns][keyColumns].options.map(function (e) {
                                            return e['id'];
                                        }).indexOf(model[keyColumns]);
                                        if (!angular.isUndefined($scope[columns][keyColumns].options[position])) {
                                            var object = $scope[columns][keyColumns].options[position].value;
                                        }
                                    }
                                }
                            } else {
                                var object = model[keyColumns];
                            }
                            var objectString = String(object).toLowerCase();
                            if (angular.isUndefined($scope.state.searchCrud) || $scope.state.searchCrud == '' || objectString.indexOf($scope.state.searchCrud.toLowerCase()) >= 0) {
                                controls = 1;
                            }

                        });
                        if (controls == 1) {
                            return true;
                        }
                    }
                };
                $scope.$watch('filters', function () {
                    $scope.filterColumn = $scope.filters;
                }, true);

                $scope.printTable = $window;
                $scope.print = function (div, title, availableColumns, columns) {
                    console.log('88')
                    angular.element(document.querySelectorAll('.invisible')).removeClass('invisible');
                    angular.element(document.querySelectorAll('#actions')).addClass('invisible');
                    angular.element(document.querySelectorAll('.actions')).addClass('invisible');
                    if (!angular.isUndefined(availableColumns) && availableColumns.length > 0) {
                        angular.forEach(columns, function (item, index) {
                            if (availableColumns.indexOf(index) < 0) {
                                angular.element(document.querySelectorAll('.' + index)).addClass('invisible');
                            }
                        });
                    }
                    var div = document.getElementById(div);

                    var title = 'Raport ';
                    if ($scope.search['reportType'] == 'reportDetail') {
                        title = title + 'detaliat';
                    }
                    if ($scope.search['reportType'] == 'reportDaily') {
                        title = title + 'zilnic';
                    }
                    if ($scope.search['reportType'] == 'reportMonthly') {
                        title = title + 'lunar';
                    }
                    if ($scope.search['reportType'] == 'reportGeneral') {
                        title = title + 'general';
                    }
                    title = title + '  ';
                    if ($scope.search['dateFrom']) {
                        title = title + moment($scope.search['dateFrom']).format('DD/MM/YY');
                    }
                    if ($scope.search['timeFrom']) {
                        title = title + moment($scope.search['timeFrom']).format(' HH:mm:ss');
                    }
                    if ($scope.search['dateFrom'] || $scope.search['timeFrom']) {
                        title = title + '   ';
                    }
                    if ($scope.search['dateTo']) {
                        title = title + moment($scope.search['dateTo']).format('DD/MM/YY');
                    }
                    if ($scope.search['timeTo']) {
                        title = title + moment($scope.search['timeTo']).format(' HH:mm:ss');
                    }

                    var popup = $scope.printTable.open('', '_blank', 'width=800,height=800,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
                    popup.window.focus();
                    popup.document.open();
                    popup.document.write('<!DOCTYPE html><html><head><title>' + title + '</title>'
                            + '<link rel="stylesheet" type="text/css" href="/css/print.css" />'
                            + '</head><body onload="window.print(); window.close();"><div>'
                            + div.outerHTML + '</div></body></html>');
                    //popup.document.close();
                }

                /* get models */
                $scope.controlAll = 0;
                $scope.getPaginateModel = function (path, offset, per_page, action, dataModel) {

                    $scope.additionals['buttonDisabledPagination'] = true;
                    $scope.range = [];
                    $scope.itemsPerPageOptions = [
                        {id: 1, name: '1'},
                        {id: 2, name: '2'},
                        {id: 5, name: '5'},
                        {id: 10, name: '10'},
                        {id: 25, name: '25'},
                        {id: 50, name: '50'},
                        {id: 0, name: 'All'}
                    ];

                    $scope.state = {};
                    if (angular.isUndefined(per_page)) {
                        if (!angular.isUndefined($scope.state.itemsPerPage)) {
                            per_page = $scope.state.itemsPerPage;
                        }
                    } else {
                        $scope.state.itemsPerPage = per_page;
                    }
                    $scope.state.page = offset;
                    if ($scope.state.page > $scope.no_pages && $scope.no_pages > 0) {
                        $scope.state.page = $scope.no_pages;
                        offset = $scope.no_pages;
                    }
                    if (per_page == 0) {
                        $scope.state.page = 1;
                        $scope.state.itemsPerPage = 0;
                    } else {
                        $scope.controlAll = 0;
                    }
                    if (angular.isUndefined($scope.no_pages)) {
                        $scope.no_pages = 1;
                    }

                    $scope.isLoadingPagination = true;
                    $scope.role_id = [];
                    $scope.$watch('no_pages', function (item) {
                        item = $scope.no_pages;
                    }, true);

                    if (angular.isUndefined($scope.defaultItem)) {
                        $scope.defaultItem = 10;
                    }

                    if ($scope.searchControl == true) {
                        Crud.search($scope.search, path, offset, per_page)
                                .success(function (data) {

                                    if (!angular.isUndefined(data['data'])) {
                                        if (angular.isUndefined(data['data'].length)) {
                                            var ar = [];
                                            for (var i = 0; i < Object.keys(data['data']).length; i++) {
                                                ar.push(data['data'][i]);
                                            }
                                            data['data'] = ar;
                                        }
                                    }

                                    $scope.isLoadingPagination = false;
                                    $scope.stop = data.next_page_url;
                                    $scope.from = data.from;
                                    $scope.to = data.to;
                                    $scope.total = data.total;
                                    $scope.last_page = data.last_page;
                                    $scope.no_pages = Math.ceil(data.total / data.per_page);
                                    if (per_page == 0) {
                                        $scope.range = [{}];
                                    } else {
                                        for (var i = 0; i < $scope.no_pages; i++) {
                                            $scope.range[i] = i;
                                        }
                                    }
                                    if (data.total <= $scope.defaultItem) {
                                        $scope.last = 1;
                                    }

                                    if ($scope.controlAll == 1) {

                                        if (angular.isUndefined($scope.last_page)) {
                                            if (data.data.length == 0) {
                                                $scope.last_page = data.current_page;
                                            } else {
                                                $scope.last_page = data.current_page + 1;
                                            }
                                        }

                                        $scope.from = 1;
                                        if (angular.isUndefined($scope.last) || data.total > $scope.defaultItem) {
                                            $scope.last = 0;
                                        }
                                        if (offset < $scope.last_page) {
                                            angular.forEach(data.data, function (item, index) {
                                                $scope.models.push(item);
                                            });
                                        }
                                        if (offset == $scope.last_page) {
                                            if ($scope.last == 0) {
                                                angular.forEach(data.data, function (item, index) {
                                                    $scope.models.push(item);
                                                });
                                            }
                                            $scope.controlAll = 0;
                                            $scope.last = 1;
                                        }
                                    } else {
                                        $scope.models = data.data;
                                    }

                                    /* reports */
                                    $scope.chartsOptionsPie = {
                                        //responsive: true,
                                        //maintainAspectRatio: true,
                                        //zoomOutPercentage: 55, // makes chart 40% smaller
                                        title: {
                                            display: true,
                                            text: '',
                                            fontSize: 11
                                        },
                                        legend: {
                                            display: true,
                                            position: "right",
                                            labels: {
                                                boxWidth: 12,
                                                fontSize: 11,
                                                padding: 5
                                            }
                                        },
                                        layout: {
                                            padding: {
                                                left: 50,
                                                right: 50,
                                                top: 50,
                                                bottom: 50
                                            }
                                        },
                                        tooltips: {
                                            titleFontSize: 12,
                                            bodyFontSize: 11
                                        },
                                        plugins: {
                                            legend: true,
                                            outlabels: {
                                                text: '%l %p',
                                                color: 'white',
                                                stretch: 10,
                                                padding: 2,
                                                percentPrecision: 2,
                                                valuePrecision: 4,
                                                font: {
                                                    resizable: true,
                                                    minSize: 12,
                                                    maxSize: 14
                                                }
                                            },
                                            labels: [
                                                /*{
                                                 render: 'label',
                                                 position: 'outside',
                                                 textMargin: 14,
                                                 //arc: true
                                                 },*/
                                                {
                                                    render: 'percentage',
                                                    precision: 2
                                                }
                                            ]
                                        }
                                    };
                                    $scope.chartsOptionsDoughnut = {
                                        //responsive: true,
                                        //maintainAspectRatio: true,
                                        //zoomOutPercentage: 55, // makes chart 40% smaller
                                        title: {
                                            display: true,
                                            text: '',
                                            fontSize: 11
                                        },
                                        legend: {
                                            display: true,
                                            position: "right",
                                            labels: {
                                                boxWidth: 12,
                                                fontSize: 11,
                                                padding: 5
                                            }
                                        },

                                        layout: {
                                            padding: {
                                                left: 50,
                                                right: 50,
                                                top: 50,
                                                bottom: 50
                                            }
                                        },
                                        tooltips: {
                                            titleFontSize: 12,
                                            bodyFontSize: 11
                                        },
                                        plugins: {
                                            legend: true,
                                            outlabels: {
                                                text: '%l %p',
                                                color: 'white',
                                                stretch: 10,
                                                padding: 2,
                                                percentPrecision: 2,
                                                valuePrecision: 4,
                                                font: {
                                                    resizable: true,
                                                    minSize: 12,
                                                    maxSize: 14
                                                }
                                            },
                                            labels: [
                                                /*{
                                                 render: 'label',
                                                 position: 'outside',
                                                 textMargin: 14,
                                                 //arc: true
                                                 },*/
                                                {
                                                    render: 'percentage',
                                                    precision: 2
                                                }
                                            ]
                                        }
                                    };
                                    $scope.chartsOptionsBar = {
                                        title: {
                                            display: true,
                                            text: '',
                                            fontSize: 11
                                        },
                                        legend: {
                                            display: true,
                                            position: 'bottom',
                                            labels: {
                                                boxWidth: 12,
                                                fontSize: 11,
                                                padding: 5
                                            }
                                        },
                                        layout: {
                                            padding: {
                                                left: 30,
                                                right: 30,
                                                top: 30,
                                                bottom: 30
                                            }
                                        },
                                        tooltips: {
                                            titleFontSize: 12,
                                            bodyFontSize: 11
                                        }
                                    }
                                    $scope.chartsOptionsHorizontalBar = {
                                        title: {
                                            display: true,
                                            text: '',
                                            fontSize: 11
                                        },
                                        legend: {
                                            display: true,
                                            position: 'bottom',
                                            labels: {
                                                boxWidth: 12,
                                                fontSize: 11,
                                                padding: 5
                                            }
                                        },
                                        layout: {
                                            padding: {
                                                left: 30,
                                                right: 30,
                                                top: 30,
                                                bottom: 30
                                            }
                                        },
                                        tooltips: {
                                            titleFontSize: 12,
                                            bodyFontSize: 11
                                        }
                                    }
                                    $scope.chartsOptionsLine = {
                                        title: {
                                            display: true,
                                            text: '',
                                            fontSize: 11
                                        },
                                        legend: {
                                            display: true,
                                            position: 'bottom',
                                            labels: {
                                                boxWidth: 12,
                                                fontSize: 11,
                                                padding: 5
                                            }
                                        },
                                        layout: {
                                            padding: {
                                                left: 30,
                                                right: 30,
                                                top: 30,
                                                bottom: 30
                                            }
                                        },
                                        tooltips: {
                                            titleFontSize: 12,
                                            bodyFontSize: 11
                                        }
                                    }

                                    if ($location.path() == '/order/reportDaily' || $location.path() == '/order/reportMonthly') {
                                        $scope.reportChartLine = 'line';
                                        $scope.chartsDataLine = $scope.models.map(function (item, index) {
                                            return parseFloat(item.total);
                                        });
                                        $scope.chartsLabelsLine = $scope.models.map(function (item, index) {
                                            if ($location.path() == '/order/reportDaily') {
                                                return $scope.additionals['formaterDate'](item['date'], 'DD/MM/YY');
                                            }
                                            if ($location.path() == '/order/reportMonthly') {
                                                if (item.month <= 9) {
                                                    item.month = '0' + item.month;
                                                }
                                                return item.month + '/' + item.year;
                                            }
                                        });
                                        $scope.datasetOverrideLine = {
                                            backgroundColor: 'rgba( 151,187,205,0.5)',
                                            label: 'Total'
                                        };
                                        $scope.chartsOptionsLine.title = {
                                            display: true,
                                            text: 'Evolutia cifrei de afaceri',
                                            fontSize: 11
                                        }

                                    }
                                    if ($location.path() == '/order/reportSource') {
                                        $scope.reportChartPie = 'pie';
                                        $scope.chartsDataPie = $scope.models.map(function (item, index) {
                                            return parseFloat(item.total);
                                        });
                                        $scope.chartsLabelsPie = $scope.models.map(function (item, index) {
                                            return $scope.additionals['associativeColumn']($scope.columns['order_source'], item['order_source']);
                                        });
                                    }
                                    if ($location.path() == '/order/reportDailySource') {
                                        $scope.reportChartDoughnut = 'doughnut';
                                        $scope.chartsDataDoughnut = $scope.models.map(function (item, index) {
                                            return parseFloat(item.total);
                                        });
                                        $scope.chartsLabelsDoughnut = $scope.models.map(function (item, index) {
                                            //return $scope.additionals['associativeColumn']($scope.columns['order_source'], item['order_source']) + ' (' +item['date'] +' )';
                                            return $scope.additionals['associativeColumn']($scope.columns['order_source'], item['order_source']);
                                        });
                                    }
                                    if ($location.path() == '/order/reportSection') {
                                        $scope.reportChartDoughnut = 'doughnut';
                                        $scope.chartsDataDoughnut = $scope.models.map(function (item, index) {
                                            return parseFloat(item.total);
                                        });
                                        $scope.chartsLabelsDoughnut = $scope.models.map(function (item, index) {
                                            if (item['section_name'] == null || item['section_name'] == 'null') {
                                                return item['locality_name'];
                                            } else {
                                                return item['section_name'];
                                            }
                                        });

                                    }
                                    if ($location.path() == '/order/reportShipping') {
                                        $scope.reportChartBar = 'bar';
                                        $scope.chartsSeriesBar = ['Total', 'Transport'];
                                        $scope.chartsDataBar = [
                                            $scope.models.map(function (item, index) {
                                                return parseFloat(item.total);
                                            }),
                                            $scope.models.map(function (item, index) {
                                                return parseFloat(item.order_shipping);
                                            })
                                        ];
                                        $scope.chartsLabelsBar = $scope.models.map(function (item, index) {
                                            if ($scope.search.period == 'daily') {
                                                return $scope.additionals['formaterDate'](item['date'], 'DD/MM/YY');
                                            }
                                            if ($scope.search.period == 'monthly') {
                                                return  $scope.additionals['formaterDate'](item['date'], 'MM/YY');
                                            }
                                            if ($scope.search.period == 'cumulative') {
                                                return item['date'];
                                            }
                                        });
                                        $scope.chartsOptionsBar.title = {
                                            display: true,
                                            text: 'Grafic de reprezentare a costului de transport in functie de valoarea totala a comenzii',
                                            fontSize: 11
                                        }
                                    }
                                    if ($location.path() == '/order/reportDiscount') {
                                        $scope.reportChartBar = 'bar';
                                        $scope.chartsSeriesBar = ['Total', 'Total discount'];
                                        $scope.chartsDataBar = [
                                            $scope.models.map(function (item, index) {
                                                return parseFloat(item.total);
                                            }),
                                            $scope.models.map(function (item, index) {
                                                return parseFloat(item.total_discount);
                                            })
                                        ];
                                        $scope.mentionChart = '* Pentru vizualizarea dispunerii tipurilor de reduceri, apasati pe fiecare coloana din grafic.';
                                        $scope.chartsLabelsBar = $scope.models.map(function (item, index) {
                                            if ($scope.search.period == 'daily') {
                                                return  $scope.additionals['formaterDate'](item['date'], 'DD/MM/YY');
                                            }
                                            if ($scope.search.period == 'monthly') {
                                                return  $scope.additionals['formaterDate'](item['date'], 'MM/YY');
                                            }
                                            if ($scope.search.period == 'cumulative') {
                                                return item['date'];
                                            }
                                        });
                                        $scope.chartsOptionsBar.title = {
                                            display: true,
                                            text: 'Distributie reduceri',
                                            fontSize: 11
                                        }
                                        $scope.chartsClickBar = function (points, evt) {
                                            //console.log(points, evt);
                                            if (!angular.isUndefined(points[0])) {
                                                var index_chart = points[0]['_index'];
                                                 if($scope.models[index_chart].total_discount != 0){
                                                        $scope.reportChartPie = 'pie';
                                                        /*$scope.chartsDataPie = [$scope.models[index_chart].order_product_discount, $scope.models[index_chart].order_client_discount, $scope.models[index_chart].order_loyalty_point_discount, $scope.models[index_chart].order_discount];
                                                        $scope.chartsLabelsPie = ['Discount produse', 'Discount client', 'Discount pct. fidelizare', 'Discount comanda'];*/
                                                  
                                                      $scope.chartsDataPie = [$scope.models[index_chart].order_product_discount, $scope.models[index_chart].order_client_discount, $scope.models[index_chart].order_discount];
                                                        $scope.chartsLabelsPie = ['Discount produse', 'Discount client', 'Discount comanda'];
                                                }
                                            }

                                        };

                                    }
                                    if ($location.path() == '/client/reportGeneral') {
                                        $scope.reportChartDoughnut = 'doughnut';
                                        $scope.chartsDataDoughnut = $scope.models.map(function (item, index) {
                                            return parseFloat(item.total);
                                        });
                                        $scope.chartsLabelsDoughnut = $scope.models.map(function (item, index) {
                                            return item['client_name'];
                                        });
                                        $scope.chartsOptionsDoughnut.title = {
                                            display: false,
                                            text: 'Distributia comenzilor pe fiecare client',
                                            fontSize: 11
                                        }
                                    }

                                    if ($location.path() == '/slot/reportGeneral') {
                                        var mod_name = 'driver';
                                        var mod_property = 'driver_name';
                                        $scope.chartsOptionsLine.title = {
                                            display: true,
                                            text: 'Distributie sloturi',
                                            fontSize: 11
                                        }
                                    }
                                    if ($location.path() == '/food-product/reportGeneral') {
                                        var mod_name = 'food_product_name';
                                        var mod_property = 'food_product_name';
                                        $scope.chartsOptionsLine.title = {
                                            display: true,
                                            text: 'Distributie vanzari produse',
                                            fontSize: 11
                                        }
                                    }
                                    if (!angular.isUndefined(mod_name)) {
                                        if ($scope.search.reportTypeGeneral == mod_name) {
                                            $scope.reportChartPie = 'pie';
                                            $scope.chartsDataPie = $scope.models.map(function (item, index) {
                                                return parseFloat(item.total);
                                            });
                                            $scope.chartsLabelsPie = $scope.models.map(function (item, index) {
                                                return item[mod_property];
                                            });

                                        }

                                        if ($scope.search.reportTypeGeneral == 'day') {
                                            $scope.reportChartLine = 'line';
                                            $scope.chartsDataLine = $scope.models.map(function (item, index) {
                                                return parseFloat(item.total);
                                            });
                                            $scope.chartsLabelsLine = $scope.models.map(function (item, index) {
                                                return $scope.additionals['formaterDate'](item['date'], 'DD/MM/YY');
                                            });
                                            $scope.datasetOverrideLine = {
                                                backgroundColor: 'rgba( 151,187,205,0.7)',
                                                label: 'Total'
                                            };

                                        }
                                    }

                                    if ($location.path() == '/slot/reportDailyDriverTime') {
                                        $scope.reportChartLine = 'line';
                                        $scope.chartsDataLine = [];
                                        $scope.datasetOverrideLine = [];
                                        var no = 0;
                                        var groups = $scope.additionals['groupArrayByProp']($scope.models, 'driver_name');
                                        angular.forEach(groups, function (itemS, indexS) {
                                            $scope.chartsDataLine[no] =
                                                    $scope.models.map(function (item, index) {
                                                        if (indexS == item['driver_name']) {
                                                            return item['average_delivery_time'];
                                                        } else {
                                                            return 0;
                                                        }
                                                    });
                                            $scope.datasetOverrideLine[no] =
                                                    {
                                                        label: indexS,
                                                        borderWidth: 3,
                                                        backgroundColor: 'rgba(241,225,48,0)',
                                                        hoverBackgroundColor: "rgba(255,99,132,0.4)",
                                                        hoverBorderColor: "rgba(255,99,132,1)",
                                                        type: 'line'
                                                    };
                                            no = no + 1;
                                        });
                                        $scope.chartsLabelsLine = $scope.models.map(function (item, index) {
                                            return $scope.additionals['formaterDate'](item['date'], 'DD/MM/YY');
                                        });
                                        $scope.chartsOptionsLine.title = {
                                            display: true,
                                            text: 'Timpul mediu de livrare per sofer',
                                            fontSize: 11
                                        }
                                        $scope.chartsOptionsLine.scales = {
                                            yAxes: [
                                                {
                                                    ticks: {
                                                        callback: function (value, index, values) {
                                                            return $scope.additionals['formatTime'](value);
                                                        }
                                                    },
                                                    id: 'y-axis-1',
                                                    type: 'linear',
                                                    display: true,
                                                    position: 'left',
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: false,
                                                    }
                                                }
                                            ],
                                            xAxes: [
                                                {
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: false,
                                                    }
                                                }
                                            ]
                                        };
                                        $scope.chartsOptionsLine.tooltips = {
                                            callbacks: {
                                                label: function (tooltipItem, data) {
                                                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                                    if (label) {
                                                        label += ': ';
                                                    }
                                                    label += $scope.additionals['formatTime'](tooltipItem.yLabel);
                                                    return label;
                                                }
                                            }
                                        }

                                    }
                                    if ($location.path() == '/slot/reportDriverTime') {
                                        $scope.reportChartLine = 'line';
                                        $scope.chartsDataLine = $scope.models.map(function (item, index) {
                                            return item.average_delivery_time;
                                        });
                                        $scope.chartsLabelsLine = $scope.models.map(function (item, index) {
                                            return item.driver_name;
                                        });
                                        $scope.datasetOverrideLine = {
                                            backgroundColor: 'rgba( 151,187,205,0.5)',
                                            label: 'Sofer'
                                        };
                                        $scope.chartsOptionsLine.title = {
                                            display: true,
                                            text: 'Timpul mediu de livrare per sofer',
                                            fontSize: 11
                                        }
                                        $scope.chartsOptionsLine.scales = {
                                            yAxes: [
                                                {
                                                    ticks: {
                                                        callback: function (value, index, values) {
                                                            return $scope.additionals['formatTime'](value);
                                                        }
                                                    },
                                                    id: 'y-axis-1',
                                                    type: 'linear',
                                                    display: true,
                                                    position: 'left',
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: false,
                                                    }
                                                }
                                            ],
                                            xAxes: [
                                                {
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: false,
                                                    }
                                                }
                                            ]
                                        };
                                        $scope.chartsOptionsLine.tooltips = {
                                            callbacks: {
                                                label: function (tooltipItem, data) {
                                                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                                    if (label) {
                                                        label += ': ';
                                                    }
                                                    label += $scope.additionals['formatTime'](tooltipItem.yLabel);
                                                    return label;
                                                }
                                            }
                                        }

                                    }

                                    if ($location.path() == '/statistic/statisticTotalOrder') {
                                        $scope.reportChartBar = 'bar';
                                        $scope.chartsSeriesBar = ['Total comenzi', 'Total transport', 'Total reduceri'];
                                        $scope.chartsDataBar = [
                                            $scope.models.map(function (item, index) {
                                                //if(item.values_orders == 0){item.values_orders = 0;}
                                                return parseFloat(item.values_orders);
                                            }),
                                            $scope.models.map(function (item, index) {
                                                return parseFloat(item.shipping_values_orders);
                                            }),
                                            $scope.models.map(function (item, index) {
                                                return parseFloat(item.discount_values_orders);
                                            })
                                        ];
                                        $scope.chartsLabelsBar = $scope.models.map(function (item, index) {
                                            return item['date'];
                                        });
                                        $scope.chartsOptionsBar.plugins = {
                                            labels: [
                                                {
                                                    // render: 'percentage',
                                                    render: function (args) {
                                                        if (Number.isNaN(args.percentage)) {
                                                            args.percentage = 0;
                                                        }
                                                        return args.percentage + '%';
                                                    },
                                                    precision: 2,
                                                }
                                            ]
                                        };
                                        $scope.reportChartLine = 'line';
                                        $scope.chartsDataLine = $scope.models.map(function (item, index) {
                                            return parseInt(item.nos_orders);
                                        });
                                        $scope.chartsLabelsLine = $scope.models.map(function (item, index) {
                                            return item['date'];
                                        });
                                        $scope.datasetOverrideLine = {
                                            backgroundColor: 'rgba( 151,187,205,0.5)',
                                            label: 'Nr. comenzi'
                                        };
                                        $scope.chartsOptionsLine.scales = {
                                            yAxes: [
                                                {
                                                    id: 'y-axis-1',
                                                    type: 'linear',
                                                    display: true,
                                                    position: 'left'
                                                }
                                            ]
                                        };

                                    }
                                    if ($location.path() == '/statistic/statisticShippingOrder') {
                                        $scope.reportChartBar = 'bar';
                                        $scope.chartsSeriesBar = ['Livrare la domiciliu', 'Livrare cu ridicare din restaurant'];
                                        $scope.chartsDataBar = [
                                            $scope.models.map(function (item, index) {
                                                return parseFloat(item.shipping_value_orders_1);
                                            }),
                                            $scope.models.map(function (item, index) {
                                                return parseFloat(item.shipping_value_orders_2);
                                            }),
                                        ];
                                        $scope.chartsLabelsBar = $scope.models.map(function (item, index) {
                                            return item['date'];
                                        });
                                        $scope.chartsOptionsBar.plugins = {
                                            labels: [
                                                {
                                                    // render: 'percentage',
                                                    render: function (args) {
                                                        if (Number.isNaN(args.percentage)) {
                                                            args.percentage = 0;
                                                        }
                                                        return args.percentage + '%';
                                                    },
                                                    precision: 2,
                                                }
                                            ]
                                        };

                                        $scope.reportChartLine = 'line';
                                        $scope.chartsDataLine = [
                                            $scope.models.map(function (item, index) {
                                                return parseInt(item.shipping_no_orders_1);
                                            }),
                                            $scope.models.map(function (item, index) {
                                                return parseInt(item.shipping_no_orders_2);
                                            }),
                                        ];
                                        $scope.chartsLabelsLine = $scope.models.map(function (item, index) {
                                            return item['date'];
                                        });
                                        $scope.datasetOverrideLine = [
                                            {
                                                label: 'Livrare la domiciliu',
                                                backgroundColor: 'rgba(151,187,205,0)'
                                            },
                                            {
                                                label: 'Livrare cu ridicare din restaurant',
                                                borderWidth: 3,
                                                borderColor: 'rgba(247, 70, 74, 1)',
                                                backgroundColor: 'rgba(241,225,48,0)',
                                                hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                hoverBorderColor: 'rgba(255,99,132,1)',
                                                type: 'line'
                                            },
                                        ];
                                        $scope.datasetOverrideBar = [
                                            {
                                                label: 'Livrare la domiciliu',
                                                backgroundColor: 'rgba(151,187,205,0.3)'
                                            },
                                            {
                                                label: 'Livrare cu ridicare din restaurant',
                                                backgroundColor: 'rgba(247, 70, 74, 0.5)',
                                                borderWidth: 3,
                                                borderColor: 'rgba(247, 70, 74, 1)',
                                                hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                hoverBorderColor: 'rgba(255,99,132,1)',
                                                type: 'line'
                                            },
                                        ];

                                        $scope.chartsOptionsBar.title = {
                                            display: true,
                                            text: 'Valoare comenzi in functie de metoda de livrare',
                                            fontSize: 11
                                        }
                                        $scope.chartsOptionsBar.scales = {
                                            yAxes: [
                                                {
                                                    id: 'y-axis-1',
                                                    type: 'linear',
                                                    display: true,
                                                    position: 'left',
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: false,
                                                    }
                                                }
                                            ],
                                            xAxes: [
                                                {
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: false,
                                                    }
                                                }
                                            ]
                                        };
                                        $scope.chartsOptionsLine.title = {
                                            display: true,
                                            text: 'Nr. comenzi in functie de metoda de livrare',
                                            fontSize: 11
                                        }
                                        $scope.chartsOptionsLine.legend = {
                                            display: false
                                        }
                                        $scope.chartsOptionsLine.scales = $scope.chartsOptionsBar.scales;

                                    }
                                    if ($location.path() == '/statistic/statisticSourceOrder') {
                                        $scope.reportChartBar = 'bar';
                                        $scope.chartsSeriesBar = [];
                                        $scope.chartsDataBar = [];
                                        var no = 0;
                                        $scope.chartsDataLine = [];
                                        $scope.datasetOverrideLine = [];
                                        angular.forEach($scope.order_source.options, function (itemS, indexS) {
                                            if (indexS != '' && itemS['id'] != 3) {
                                                $scope.chartsSeriesBar[no] = itemS['value'];
                                                $scope.chartsDataBar[no] =
                                                        $scope.models.map(function (item, index) {
                                                            return parseFloat(item['source_value_orders_' + itemS["id"]]);
                                                        });
                                                $scope.chartsDataLine[no] =
                                                        $scope.models.map(function (item, index) {
                                                            return parseFloat(item['source_no_orders_' + itemS["id"]]);
                                                        });
                                                $scope.datasetOverrideLine[no] =
                                                        {
                                                            label: itemS['value'],
                                                            borderWidth: 3,
                                                            //borderColor: "rgba(247, 70, 74, 1)",
                                                            backgroundColor: 'rgba(241,225,48,0)',
                                                            hoverBackgroundColor: "rgba(255,99,132,0.4)",
                                                            hoverBorderColor: "rgba(255,99,132,1)",
                                                            type: 'line'
                                                        };
                                                no = no + 1;
                                            }
                                        });
                                        $scope.chartsLabelsBar = $scope.models.map(function (item, index) {
                                            return item['date'];
                                        });
                                        $scope.chartsOptionsBar.plugins = {
                                            labels: [
                                                {
                                                    // render: 'percentage',
                                                    render: function (args) {
                                                        if (Number.isNaN(args.percentage)) {
                                                            args.percentage = 0;
                                                        }
                                                        return args.percentage + '%';
                                                    },
                                                    precision: 2,
                                                }
                                            ]
                                        };
                                        $scope.reportChartLine = 'line';
                                        $scope.chartsLabelsLine = $scope.models.map(function (item, index) {
                                            return item['date'];
                                        });
                                        $scope.chartsOptionsLine.legend = {
                                            display: false
                                        }
                                        $scope.chartsOptionsBar.title = {
                                            display: true,
                                            text: 'Valoare comenzi pe surse de provenienta',
                                            fontSize: 11
                                        }
                                        $scope.chartsOptionsLine.title = {
                                            display: true,
                                            text: 'Nr. comenzi pe surse de provenienta',
                                            fontSize: 11
                                        }
                                        $scope.chartsOptionsBar.scales = {
                                            yAxes: [
                                                {
                                                    id: 'y-axis-1',
                                                    type: 'linear',
                                                    display: true,
                                                    position: 'left',
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: false,
                                                    }
                                                }
                                            ],
                                            xAxes: [
                                                {
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: false,
                                                    }
                                                }
                                            ]
                                        };
                                        $scope.chartsOptionsLine.scales = $scope.chartsOptionsBar.scales;
                                    }
                                    if ($location.path() == '/statistic/statisticDiscountOrder') {
                                        $scope.reportChartHorizontalBar = 'horizontal-bar';
                                        $scope.chartsSeriesHorizontalBar = [];
                                        $scope.chartsDataHorizontalBar = [];
                                        var no = 0;
                                        $scope.chartsDataLine = [];
                                        $scope.datasetOverrideLine = [];
                                        angular.forEach($scope.discounts, function (itemS, indexS) {
                                            $scope.chartsSeriesHorizontalBar[no] = itemS['value'];
                                            $scope.chartsDataHorizontalBar[no] =
                                                    $scope.models.map(function (item, index) {
                                                        return parseFloat(item['discount_value_orders_' + itemS["id"]]);
                                                    });
                                            $scope.chartsDataLine[no] =
                                                    $scope.models.map(function (item, index) {
                                                        return parseFloat(item['discount_no_orders_' + itemS["id"]]);
                                                    });
                                            $scope.datasetOverrideLine[no] =
                                                    {
                                                        label: itemS['value'],
                                                        borderWidth: 3,
                                                        //borderColor: "rgba(247, 70, 74, 1)",
                                                        backgroundColor: 'rgba(241,225,48,0)',
                                                        hoverBackgroundColor: "rgba(255,99,132,0.4)",
                                                        hoverBorderColor: "rgba(255,99,132,1)",
                                                        type: 'line'
                                                    };
                                            no = no + 1;
                                        });
                                        $scope.chartsLabelsHorizontalBar = $scope.models.map(function (item, index) {
                                            return item['date'];
                                        });
                                        $scope.reportChartLine = 'line';
                                        $scope.chartsLabelsLine = $scope.models.map(function (item, index) {
                                            return item['date'];
                                        });
                                        $scope.chartsOptionsLine.legend = {
                                            display: false
                                        }
                                        $scope.chartsOptionsHorizontalBar.title = {
                                            display: true,
                                            text: 'Valoare comenzi in functie de tipurile de reduceri',
                                            fontSize: 11
                                        }
                                        $scope.chartsOptionsLine.title = {
                                            display: true,
                                            text: 'Nr. comenzi in functie de tipurile de reduceri',
                                            fontSize: 11
                                        }
                                        $scope.chartsOptionsHorizontalBar.scales = {
                                            yAxes: [
                                                {
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: false,
                                                    }
                                                }
                                            ],
                                            xAxes: [
                                                {
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: false,
                                                    }
                                                }
                                            ]
                                        };
                                        $scope.chartsOptionsLine.scales = $scope.chartsOptionsHorizontalBar.scales;
                                    }
                                    if ($location.path() == '/statistic/statisticDeliveryTimeDriver') {
                                        $scope.reportChartBar = 'bar';
                                        $scope.chartsDataBar =
                                                $scope.models.map(function (item, index) {
                                                    return item['value_delivery_time_grouped'];
                                                });
                                        $scope.datasetOverrideBar = {
                                            label: 'Timp mediu de livrare',
                                            borderWidth: 3,
                                            //borderColor: "rgba(247, 70, 74, 1)",
                                            backgroundColor: 'rgba(241,225,48,0)',
                                            hoverBackgroundColor: "rgba(255,99,132,0.4)",
                                            hoverBorderColor: "rgba(255,99,132,1)",
                                            type: 'line'
                                        };
                                        $scope.chartsLabelsBar = $scope.models.map(function (item, index) {
                                            return item['date'];
                                        });
                                        $scope.chartsOptionsBar.legend = {
                                            display: false
                                        }
                                        $scope.chartsOptionsBar.title = {
                                            display: true,
                                            text: 'Timpul mediu de livrare per zi/luna',
                                            fontSize: 11
                                        }
                                        $scope.chartsOptionsBar.scales = {
                                            yAxes: [
                                                {
                                                    ticks: {
                                                        callback: function (value, index, values) {
                                                            return $scope.additionals['formatTime'](value);
                                                        }
                                                    },
                                                    id: 'y-axis-1',
                                                    type: 'linear',
                                                    display: true,
                                                    position: 'left',
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: true,
                                                    }
                                                }
                                            ],
                                            xAxes: [
                                                {
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: true,
                                                    }
                                                }
                                            ]
                                        };
                                        $scope.chartsOptionsBar.tooltips = {
                                            callbacks: {
                                                label: function (tooltipItem, data) {
                                                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                                    if (label) {
                                                        label += ': ';
                                                    }
                                                    label += $scope.additionals['formatTime'](tooltipItem.yLabel);
                                                    return label;
                                                }
                                            }
                                        }
                                        $scope.chartsOptionsBar.plugins = {
                                            labels: []
                                        }

                                        var oldGroups = [];
                                        $scope.models.map(function (item, index) {
                                            if (item['drivers'].length > 0) {
                                                item['drivers'].map(function (itemDriver, indexDriver) {
                                                    oldGroups.push(itemDriver);
                                                });
                                            }
                                        });
                                        $scope.reportChartLine = 'line';
                                        $scope.chartsDataLine = [];
                                        $scope.datasetOverrideLine = [];
                                        var no = 0;
                                        var groups = $scope.additionals['groupArrayByProp'](oldGroups, 'driver_name');
                                        angular.forEach(groups, function (itemS, indexS) {
                                            $scope.chartsDataLine[no] =
                                                    $scope.models.map(function (item, index) {
                                                        var valueTime = "0";
                                                        angular.forEach(itemS, function (itemSS, indexSS) {
                                                            if (item['date'] == itemSS['date']) {
                                                                valueTime = itemSS['value_delivery_time'];
                                                            }
                                                        });
                                                        return valueTime;
                                                    });
                                            $scope.datasetOverrideLine[no] =
                                                    {
                                                        label: indexS,
                                                        borderWidth: 3,
                                                        backgroundColor: 'rgba(241,225,48,0)',
                                                        hoverBackgroundColor: "rgba(255,99,132,0.4)",
                                                        hoverBorderColor: "rgba(255,99,132,1)",
                                                        type: 'line'
                                                    };
                                            no = no + 1;
                                        });
                                        $scope.chartsLabelsLine = $scope.models.map(function (item, index) {
                                            return item['date'];
                                        });
                                        $scope.chartsOptionsLine.title = {
                                            display: true,
                                            text: 'Timpul mediu de livrare per sofer',
                                            fontSize: 11
                                        }
                                        $scope.chartsOptionsLine.scales = {
                                            yAxes: [
                                                {
                                                    ticks: {
                                                        callback: function (value, index, values) {
                                                            return $scope.additionals['formatTime'](value);
                                                        }
                                                    },
                                                    id: 'y-axis-1',
                                                    type: 'linear',
                                                    display: true,
                                                    position: 'left',
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: true,
                                                    }
                                                }
                                            ],
                                            xAxes: [
                                                {
                                                    gridLines: {
                                                        display: true,
                                                        drawBorder: true,
                                                        drawOnChartArea: true,
                                                    }
                                                }
                                            ]
                                        };
                                        $scope.chartsOptionsLine.tooltips = {
                                            callbacks: {
                                                label: function (tooltipItem, data) {
                                                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                                    if (label) {
                                                        label += ': ';
                                                    }
                                                    label += $scope.additionals['formatTime'](tooltipItem.yLabel);
                                                    return label;
                                                }
                                            }
                                        }

                                    }
                                    /* end reports */

                                    $scope.models.per_page = data.per_page;
                                    $scope.models.current_page = data.current_page;
                                    $scope.selected = {};
                                    $scope.selectedAll = false;
                                    $scope.additionals['buttonDisabledPagination'] = false;

                                    if ($scope.state.itemsPerPage == 0) {
                                        $timeout(function () {
                                            $scope.controlAll = 1;
                                        }, 100);
                                    }
                                })
                                .error(function (data) {
                                    $scope.isLoadingPagination = false;
                                    $scope.errors = data.errors;
                                    if (data == null) {
                                        $rootScope.checkNetworkConnection();
                                    }
                                })
                                ;
                    } else {
                        Crud.index(path, offset, per_page)
                                .success(function (data) {
                                    if (!angular.isUndefined(data.invalid)) {
                                        $scope.additionals['invalid'] = data.invalid;
                                    } else {

                                        $scope.stop = data.next_page_url;
                                        $scope.from = data.from;
                                        $scope.to = data.to;
                                        $scope.total = data.total;
                                        $scope.last_page = data.last_page;
                                        $scope.no_pages = Math.ceil(data.total / data.per_page);

                                        if (per_page == 0) {
                                            $scope.range = [{}];
                                        } else {
                                            for (var i = 0; i < $scope.no_pages; i++) {
                                                $scope.range[i] = i;
                                            }
                                        }

                                        if (data.total <= $scope.defaultItem) {
                                            $scope.last = 1;
                                        }
                                        if ($scope.controlAll == 1) {

                                            if (angular.isUndefined($scope.last_page)) {
                                                if (data.data.length == 0) {
                                                    $scope.last_page = data.current_page;
                                                } else {
                                                    $scope.last_page = data.current_page + 1;
                                                }
                                            }

                                            $scope.from = 1;
                                            if (angular.isUndefined($scope.last) || data.total > $scope.defaultItem) {
                                                $scope.last = 0;
                                            }
                                            if (offset < $scope.last_page) {
                                                angular.forEach(data.data, function (item, index) {
                                                    $scope.models.push(item);
                                                });
                                            }
                                            if (offset == $scope.last_page) {
                                                if ($scope.last == 0) {
                                                    angular.forEach(data.data, function (item, index) {
                                                        $scope.models.push(item);
                                                    });
                                                }
                                                $scope.controlAll = 0;
                                                $scope.last = 1;
                                            }
                                        } else {
                                            $scope.models = data.data;
                                        }
                                        $scope.models.per_page = data.per_page;
                                        $scope.models.current_page = data.current_page;
                                        $scope.selected = {};
                                        $scope.selectedAll = false;

                                        if ($scope.state.itemsPerPage == 0) {
                                            $timeout(function () {
                                                $scope.controlAll = 1;
                                            }, 100);
                                        }

                                    }
                                    $scope.isLoadingPagination = false;
                                    $scope.additionals['buttonDisabledPagination'] = false;

                                })
                                .error(function (data) {
                                    $scope.isLoadingPagination = false;
                                    $scope.errors = data.errors;
                                    if (data == null) {
                                        $rootScope.checkNetworkConnection();
                                    }
                                });
                    }

                };

                $scope.selectAll = function () {
                    if ($scope.state.itemsPerPage == 0) {
                        angular.element(document.querySelector('.fill-height')).animate({scrollTop: 200}, 'slow');
                        $scope.last = 0;
                    }
                }

                $scope.additionals = {};
                $scope.controlSH = false;

                $scope.additionals['makeDropDown'] = function (parents, prop) {
                    $scope.additionals['data'] = [];
                    angular.forEach(parents, function (parent) {
                        $scope.additionals['data'].push(parent);
                        if (!angular.isUndefined(parent['children_recursive'])) {
                            $scope.additionals['subDropDown'](parent['children_recursive'], prop, '-');
                        }
                    });
                    return $scope.additionals['data'];
                }

                $scope.additionals['subDropDown'] = function (children, prop, space) {
                    angular.forEach(children, function (child, childKey) {
                        var childArray = child;
                        childArray[prop] = space + child[prop];
                        $scope.additionals['data'].push(childArray);
                        if (!angular.isUndefined(child['children_recursive'])) {
                            $scope.additionals['subDropDown'](child['children_recursive'], prop, space + '-');
                        }
                    });
                }

                function dataURLtoBlob(dataurl) {
                    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }
                    return new Blob([u8arr], {type: mime});
                }

                /* add media model */
                $scope.addMediaModel = function (ev, path, model, section, typeRequest) {
                    if ($scope.mode_action == 'page') {
                        $scope.controlSH = true;
                        $scope.action = 'media';
                        angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, 'slow');

                        $scope.additionals['invalid'] = '';

                        var currentModel = {};
                        angular.forEach(model, function (item, key) {
                            currentModel[key] = item;
                        });
                        $scope.modelData = currentModel;
                        angular.element(document.querySelector('#fileImage')).val('');

                        $scope.cancel = function () {
                            $scope.modelData = {};
                            $scope.errors = {};
                            $scope.controlSH = false;
                        };

                        /* add media to model */
                        $scope.addMedia = function () {
                            $scope.additionals['buttonDisabled'] = true;
                            $scope.isLoading = true;

                            if (typeRequest == 'form-urlencoded') {
                                $scope.post = $scope.modelData;
                            }

                            if (typeRequest == 'undefined') {
                                $scope.post = new FormData();

                                if (!angular.isUndefined($scope.modelData.images)) {
                                    angular.forEach($scope.modelData.images, function (item, key) {
                                        if (key != 0) {
                                            var blob = dataURLtoBlob(item);
                                            $scope.post.append('images[]', blob, 'generic-' + key + '.jpg');
                                        }
                                    });
                                }

                                $scope.post.append('route', 'media');
                                $scope.post.append('id', model[$rootScope.typeId]);
                            }
                            if (typeRequest == 'json') {
                                $scope.post = $scope.modelData;
                            }
                            Crud.post(typeRequest, $scope.post, $scope.path + '/media')
                                    .success(function (data) {
                                        if (!angular.isUndefined(data.invalid)) {
                                            $scope.additionals['invalid'] = data.invalid;
                                        } else {
                                            if (!angular.isUndefined(data.currentModel)) {
                                                if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                                    $scope.getElement($scope.models, data.currentModel);
                                                }
                                                if (!angular.isUndefined($scope.modelData)) {
                                                    $scope.modelData = data.currentModel;
                                                }
                                            } else {
                                                if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                                    $scope.getElement($scope.models, currentModel);
                                                }
                                                if (!angular.isUndefined($scope.modelData)) {
                                                    $scope.modelData = currentModel;
                                                }
                                            }
                                        }
                                        $scope.modelData = {};
                                        $scope.errors = {};
                                        $scope.isLoading = false;
                                        $scope.controlSH = false;
                                        $scope.additionals['buttonDisabled'] = false;

                                    }).error(function (data) {
                                $scope.errors = data.errors;
                                $scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
                                if (data == null) {
                                    $rootScope.checkNetworkConnection();
                                }
                            });
                        };

                    }
                    if ($scope.mode_action == 'dialog') {
                        $scope.additionals['invalid'] = '';
                        var currentModel = {};
                        angular.forEach(model, function (item, key) {
                            currentModel[key] = item;
                        });
                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'mediaDialog.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {
                                pathTemplate: $scope.pathTemplate,
                                path: $scope.path,
                                section: section,
                                model: currentModel,
                                selected: $scope.selected,
                                additionals: $scope.additionals
                            }
                        }).then(function () {
                            if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                                if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                                    if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                                    }
                                    if (!angular.isUndefined($scope.modelData)) {
                                        $scope.modelData = $scope.additionals['dataCurrentModel'];
                                    }
                                } else {
                                    if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                                    }
                                    if (!angular.isUndefined($scope.modelData)) {
                                        $scope.modelData = currentModel;
                                    }
                                }
                            }
                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'path', 'section', 'model', 'selected', 'additionals'];
                        function DialogController($scope, $mdDialog, pathTemplate, path, section, model, selected, additionals) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.path = path;
                            $scope.modelData = model;
                            $scope.additionals = additionals;
                            $scope.selected = selected;
                            $scope.section = section;

                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                            /* add media to model */
                            $scope.addMedia = function () {
                                $scope.additionals['buttonDisabled'] = true;
                                $scope.loading = true;

                                if (typeRequest == 'form-urlencoded') {
                                    $scope.post = $scope.modelData;
                                }
                                if (typeRequest == 'undefined') {
                                    $scope.post = new FormData();
                                    angular.forEach($scope.modelData.images, function (item, key) {
                                        if (key != 0) {
                                            var blob = dataURLtoBlob(item);
                                            $scope.post.append('images[]', blob, 'generic-' + key + '.jpg');
                                        }
                                    });
                                    $scope.post.append('route', 'media');
                                    $scope.post.append('id', model[$rootScope.typeId]);
                                }
                                if (typeRequest == 'json') {
                                    $scope.post = $scope.modelData;
                                }

                                Crud.post(typeRequest, $scope.post, $scope.path + '/media')
                                        .success(function (data) {
                                            if (!angular.isUndefined(data.invalid)) {
                                                $scope.additionals['invalid'] = data.invalid;
                                            } else {
                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                    $scope.additionals['functionResult'](ev, data);
                                                }
                                                if (!angular.isUndefined(data.currentModel)) {
                                                    $scope.additionals['dataCurrentModel'] = data.currentModel;
                                                }
                                            }
                                            $mdDialog.hide();
                                            $scope.isLoading = false;
                                            $scope.additionals['buttonDisabled'] = false;

                                        }).error(function (data) {
                                    $scope.errors = data.errors;
                                    $scope.isLoading = false;
                                    $scope.additionals['buttonDisabled'] = false;
                                    if (data == null) {
                                        $rootScope.checkNetworkConnection();
                                    }
                                });
                            };
                        }
                    }
                };

                /* create model */
                $scope.createModel = function (ev, path, section) {

                    $scope.controlSH = true;
                    if ($scope.mode_action == 'page') {
                        $scope.action = 'store';
                        $scope.errors = {};

                        $scope.additionals['invalid'] = '';
                        $scope.modelData = {};

                        $scope.cancel = function () {
                            $scope.modelData = {};
                            $scope.errors = {};
                            $scope.controlSH = false;
                        };
                        if (!angular.isUndefined($scope.additionals['function'])) {
                            $scope.additionals['function'](ev, $scope.modelData);
                        }

                        /* save a model */
                        $scope.saveModel = function () {

                            $scope.additionals['buttonDisabled'] = true;
                            if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                $scope.additionals['internFunction'](ev, $scope.modelData);
                            }
                            $scope.isLoading = true;
                            $scope.modelData['field'] = $scope.search['field'];
                            $scope.modelData['order'] = $scope.search['order'];

                            if ($scope.additionals['content_type'] == 'form-urlencoded') {
                                $scope.post = $scope.modelData;
                            }
                            if ($scope.additionals['content_type'] == 'undefined') {
                                $scope.post = new FormData();
                                angular.forEach($scope.modelData, function (item, key) {
                                    $scope.post.append(key, item);
                                });
                            }
                            if ($scope.additionals['content_type'] == 'json') {
                                $scope.post = $scope.modelData;
                            }
                            Crud.save($scope.additionals['content_type'], $scope.post, path)
                                    .success(function (data) {
                                        if (!angular.isUndefined(data.invalid)) {
                                            $scope.additionals['invalid'] = data.invalid;
                                        } else {
                                            if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                $scope.additionals['functionResult'](ev, data);
                                            }
                                            if (!angular.isUndefined(data.position)) {
                                                var no_pages = Math.ceil((data.position + 1) / $scope.state.itemsPerPage);
                                            } else {
                                                var no_pages = Math.ceil(($scope.total + 1) / $scope.state.itemsPerPage);
                                            }

                                            if ($route.current.$$route.originalPath != '/order/getOrder' && $route.current.$$route.originalPath != '/order') {
                                                if ($scope.state.itemsPerPage == 0) {
                                                    if (!angular.isUndefined(data.position) && !angular.isUndefined(data.currentModel)) {
                                                        $scope.models.splice(data.position, 0, data.currentModel);
                                                    } else {
                                                        $scope.getPaginateModel(path, no_pages, $scope.state.itemsPerPage);
                                                    }
                                                }
                                                if ($scope.state.itemsPerPage != 0) {
                                                    $scope.getPaginateModel(path, no_pages, $scope.state.itemsPerPage);
                                                }
                                            } else {
                                                if (data.currentModel) {
                                                    var post = {};
                                                    post['id'] = data.currentModel.id;
                                                    post['route'] = 'printOrderAsincron';
                                                    $scope.additionals['printOrderAsincron'](path, post);
                                                }
                                            }

                                            if (!angular.isUndefined(data.newDependentFields)) {
                                                angular.forEach(data.newDependentFields, function (item, key) {
                                                    if (item instanceof Array) {
                                                        angular.forEach(item, function (itemArray, keyArray) {
                                                            $scope.additionals[key].push(itemArray);
                                                        });
                                                    } else {
                                                        $scope.additionals[key].push(item);
                                                    }
                                                });
                                            }
                                        }
                                        $scope.modelData = {};
                                        $scope.errors = {};
                                        $scope.isLoading = false;
                                        $scope.controlSH = false;
                                        $scope.additionals['buttonDisabled'] = false;
                                    })
                                    .error(function (data) {
                                        $scope.isLoading = false;
                                        $scope.errors = data.errors;
                                        $scope.additionals['buttonDisabled'] = false;
                                        if (!angular.isUndefined($scope.additionals['functionErrors'])) {
                                            $scope.additionals['functionErrors'](ev, data);
                                        }
                                        if (data == null) {
                                            $rootScope.checkNetworkConnection();
                                        }
                                    });
                        };
                    }
                    
                    if ($scope.mode_action == 'dialog') {
                        $scope.errors = {};
                        $scope.additionals['invalid'] = '';
                        $scope.modelData = {};
                        $scope.action = 'store';
                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'createDialog.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {pathTemplate: $scope.pathTemplate, section: section, model: $scope.modelData, additionals: $scope.additionals, search: $scope.search, action: $scope.action}
                        }).then(function (saveModel) {
                            if (!angular.isUndefined($scope.additionals['position'])) {
                                var no_pages = Math.ceil(($scope.additionals['position'] + 1) / $scope.state.itemsPerPage);
                            } else {
                                var no_pages = Math.ceil(($scope.total + 1) / $scope.state.itemsPerPage);
                            }
                            if ($scope.state.itemsPerPage == 0) {
                                if (!angular.isUndefined($scope.additionals['position']) && !angular.isUndefined($scope.additionals['currentModel'])) {
                                    $scope.models.splice($scope.additionals['position'], 0, $scope.additionals['currentModel']);
                                } else {
                                    $scope.getPaginateModel(path, no_pages, $scope.state.itemsPerPage);
                                }
                            }
                            if ($scope.state.itemsPerPage != 0) {
                                $scope.getPaginateModel(path, no_pages, $scope.state.itemsPerPage);
                            }

                        });

                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'additionals', 'search', 'action'];
                        function DialogController($scope, $mdDialog, pathTemplate, section, model, additionals, search, action) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };
                            $scope.modelData = model;
                            $scope.section = section;
                            $scope.additionals = additionals;
                            $scope.search = search;
                            $scope.action = action;

                            if (!angular.isUndefined($scope.additionals['function'])) {
                                $scope.additionals['function'](ev, $scope.modelData);
                            }

                            /* save a model */
                            $scope.saveModel = function () {
                                $scope.additionals['buttonDisabled'] = true;
                                if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                    $scope.additionals['internFunction'](ev, $scope.modelData);
                                }
                                $scope.isLoading = true;
                                $scope.modelData['field'] = $scope.search['field'];
                                $scope.modelData['order'] = $scope.search['order'];

                                if ($scope.additionals['content_type'] == 'form-urlencoded') {
                                    $scope.post = $scope.modelData;
                                }
                                if ($scope.additionals['content_type'] == 'undefined') {
                                    $scope.post = new FormData();
                                    angular.forEach($scope.modelData, function (item, key) {
                                        $scope.post.append(key, item);
                                    });
                                }
                                if ($scope.additionals['content_type'] == 'json') {
                                    $scope.post = $scope.modelData;
                                }

                                Crud.save($scope.additionals['content_type'], $scope.post, path)
                                        .success(function (data) {
                                            if (!angular.isUndefined(data.invalid)) {
                                                $scope.additionals['invalid'] = data.invalid;
                                            } else {
                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                    $scope.additionals['functionResult'](ev, data);
                                                }
                                                if (!angular.isUndefined(data.position)) {
                                                    $scope.additionals['position'] = data.position;
                                                }
                                                if (!angular.isUndefined(data.currentModel)) {
                                                    $scope.additionals['currentModel'] = data.currentModel;
                                                }
                                                if (!angular.isUndefined(data.newDependentFields)) {
                                                    angular.forEach(data.newDependentFields, function (item, key) {
                                                        if (item instanceof Array) {
                                                            angular.forEach(item, function (itemArray, keyArray) {
                                                                $scope.additionals[key].push(itemArray);
                                                            });
                                                        } else {
                                                            $scope.additionals[key].push(item);
                                                        }
                                                    });
                                                }

                                            }
                                            $scope.isLoading = false;
                                            $mdDialog.hide();
                                            $scope.additionals['buttonDisabled'] = false;
                                        })
                                        .error(function (data) {
                                            $scope.isLoading = false;
                                            $scope.errors = data.errors;
                                            if (!angular.isUndefined($scope.additionals['functionErrors'])) {
                                                $scope.additionals['functionErrors'](ev, data);
                                            }
                                            $scope.additionals['buttonDisabled'] = false;
                                            if (data == null) {
                                                $rootScope.checkNetworkConnection();
                                            }
                                        });
                            };
                        }
                    }
                }

                /* update model */
                $scope.editModel = function (ev, path, model, section) {
                    if ($scope.mode_action == 'page') {
                        $scope.controlSH = true;
                        $scope.action = 'update';
                        $scope.errors = {};

                        if ($location.path() == '/slot') {
                            var positionAction = $('.class-action').position();
                            angular.element(document.querySelector('.fill-height')).animate({scrollTop: positionAction.top}, 'slow');
                        } else {
                            angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, 'slow');
                        }

                        $scope.additionals['invalid'] = '';
                        var currentModel = {};
                        angular.forEach(model, function (item, key) {
                            currentModel[key] = item;
                        });
                        $scope.modelData = currentModel;

                        $scope.cancel = function () {
                            $scope.modelData = {};
                            $scope.errors = {};
                            $scope.controlSH = false;
                        };

                        if (!angular.isUndefined($scope.additionals['function'])) {
                            $scope.additionals['function'](ev, $scope.modelData);
                        }

                        $scope.updateModel = function () {
                            $scope.additionals['buttonDisabled'] = true;

                            if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                $scope.additionals['internFunction'](ev, $scope.modelData);
                            }
                            $scope.isLoading = true;

                            Crud.update($scope.additionals['content_type'], $scope.modelData, $rootScope.typeId, path)
                                    .success(function (data) {
                                        if (!angular.isUndefined(data.invalid)) {
                                            $scope.additionals['invalid'] = data.invalid;
                                        } else {
                                            if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                $scope.additionals['functionResult'](ev, data);
                                            }
                                            /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                             $scope.selected[model[$rootScope.typeId]] = model;
                                             }*/
                                            if (!angular.isUndefined(data.currentModel)) {
                                                if (!angular.isUndefined($scope.models)) {
                                                    $scope.getElement($scope.models, data.currentModel);
                                                }
                                                if (!angular.isUndefined($scope.modelData)) {
                                                    $scope.modelData = data.currentModel;
                                                }
                                            } else {
                                                if (!angular.isUndefined($scope.models)) {
                                                    $scope.getElement($scope.models, currentModel);
                                                }
                                                if (!angular.isUndefined($scope.modelData)) {
                                                    $scope.modelData = currentModel;
                                                }
                                            }

                                            if ($route.current.$$route.originalPath == '/order/getOrder' || $route.current.$$route.originalPath == '/order') {
                                                if (data.currentModel) {
                                                    var post = {};
                                                    post['id'] = data.currentModel.id;
                                                    post['route'] = 'printOrderAsincron';
                                                    $scope.additionals['printOrderAsincron'](path, post);
                                                }
                                            }

                                        }
                                        $scope.modelData = {};
                                        $scope.errors = {};
                                        $scope.isLoading = false;
                                        $scope.controlSH = false;
                                        $scope.additionals['buttonDisabled'] = false;
                                    })
                                    .error(function (data) {
                                        $scope.isLoading = false;
                                        $scope.errors = data.errors;
                                        $scope.additionals['buttonDisabled'] = false;
                                        if (data == null) {
                                            $rootScope.checkNetworkConnection();
                                        }
                                    });
                        };
                    }
                    if ($scope.mode_action == 'dialog') {

                        $scope.additionals['invalid'] = '';
                        $scope.errors = {};
                        $scope.action = 'update';
                        var currentModel = {};

                        angular.forEach(model, function (item, key) {
                            currentModel[key] = item;
                        });

                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'editDialog.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {
                                pathTemplate: $scope.pathTemplate,
                                section: section,
                                model: currentModel,
                                selected: $scope.selected,
                                additionals: $scope.additionals,
                                action: $scope.action
                            }
                        }).then(function () {
                            if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                                if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                                    if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                                    }
                                    if (!angular.isUndefined($scope.modelData)) {
                                        $scope.modelData = $scope.additionals['dataCurrentModel'];
                                    }
                                } else {
                                    if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                                    }
                                    if (!angular.isUndefined($scope.modelData)) {
                                        $scope.modelData = currentModel;
                                    }
                                }

                            }
                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals', 'action'];
                        function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals, action) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.modelData = model;
                            $scope.additionals = additionals;
                            $scope.selected = selected;
                            $scope.section = section;
                            $scope.action = action;


                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                            if (!angular.isUndefined($scope.additionals['function'])) {
                                $scope.additionals['function'](ev, $scope.modelData);
                            }
                            //console.log($scope.additionals['address'])
                            // console.log($scope.modelData)
                            if ($rootScope.path == '/client') {
                                $scope.additionals['cloneItem'] = function (model, modelLength) {
                                    if ($scope.action == 'store') {
                                        $scope.additionals['selectedItemLocality'][modelLength - 1] = '';
                                        $scope.additionals['selectedItemStreet'][modelLength - 1] = '';
                                    }
                                    $scope.additionals[model][modelLength] = {};
                                    $scope.modelData[model][modelLength] = {};

                                    if (angular.isUndefined($scope.modelData[model][modelLength].county_name)) {
                                        $scope.modelData[model][modelLength].county_name = 'Cluj';
                                    }
                                }

                                $scope.additionals['removeItem'] = function (itemIndex, modelAddress) {
                                    if (!angular.isUndefined($scope.errors)) {
                                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.county_name'])) {
                                            delete $scope.errors['address.' + itemIndex + '.county_name'];
                                        }
                                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.county_name'])) {
                                            delete $scope.errors['address.' + itemIndex + '.county_name'];
                                        }
                                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.section_name'])) {
                                            delete $scope.errors['address.' + itemIndex + '.section_name'];
                                        }
                                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.street_id'])) {
                                            delete $scope.errors['address.' + itemIndex + '.street_id'];
                                        }
                                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.street_no'])) {
                                            delete $scope.errors['address.' + itemIndex + '.street_no'];
                                        }
                                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_block'])) {
                                            delete $scope.errors['address.' + itemIndex + '.address_block'];
                                        }
                                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.section_name'])) {
                                            delete $scope.errors['address.' + itemIndex + '.section_name'];
                                        }
                                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_flat'])) {
                                            delete $scope.errors['address.' + itemIndex + '.address_flat'];
                                        }
                                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_type'])) {
                                            delete $scope.errors['address.' + itemIndex + '.address_type'];
                                        }
                                    }

                                    $scope.interm = [];
                                    angular.forEach($scope.additionals[modelAddress], function (itemy, indexy) {
                                        $scope.interm[indexy] = {
                                            'id': itemy['id'],
                                            'street_id': itemy['street_id'],
                                            'county_name': itemy['county_name'],
                                            'county_name': itemy['county_name'],
                                            'section_name': itemy['section_name'],
                                            'street_name': itemy['street_name'],
                                            'address_no': itemy['address_no'],
                                            'address_block': itemy['address_block'],
                                            'section_name': itemy['section_name'],
                                            'address_flat': itemy['address_flat'],
                                            'address_type': itemy['address_type']
                                        };
                                    });
                                    $scope.interms = [];
                                    angular.forEach($scope.interm, function (itemyy, indexyy) {
                                        $scope.interms.push({
                                            'id': itemyy['id'],
                                            'street_id': itemyy['street_id'],
                                            'county_name': itemyy['county_name'],
                                            'county_name': itemyy['county_name'],
                                            'section_name': itemyy['section_name'],
                                            'street_name': itemyy['street_name'],
                                            'address_no': itemyy['address_no'],
                                            'address_block': itemyy['address_block'],
                                            'section_name': itemyy['section_name'],
                                            'address_flat': itemyy['address_flat'],
                                            'address_type': itemyy['address_type']
                                        });
                                    });

                                    $scope.interms.splice(itemIndex, 1);
                                    $scope.additionals[modelAddress] = $scope.interms;

                                    $timeout(function () {
                                        /*if(!angular.isUndefined($scope.additionals[model][itemIndex]) ) {
                                         $scope.modelData.address[itemIndex].county_name = $scope.additionals[model][itemIndex].county_name;
                                         }*/
                                        $scope.modelData.address = $scope.additionals[modelAddress];

                                    }, 100);
                                }
                            }

                            $scope.updateModel = function () {
                                $scope.additionals['buttonDisabled'] = true;
                                if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                    $scope.additionals['internFunction'](ev, $scope.modelData);
                                }
                                $scope.isLoading = true;

                                Crud.update($scope.additionals['content_type'], model, $rootScope.typeId, path)
                                        .success(function (data) {
                                            if (!angular.isUndefined(data.invalid)) {
                                                $scope.additionals['invalid'] = data.invalid;
                                            } else {
                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                    $scope.additionals['functionResult'](ev, data);
                                                }
                                                /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                                 $scope.selected[model[$rootScope.typeId]] = model;
                                                 }*/
                                                if (!angular.isUndefined(data.currentModel)) {
                                                    $scope.additionals['dataCurrentModel'] = data.currentModel;
                                                    $scope.additionals['newDependentFields'] = data.newDependentFields;
                                                }

                                            }
                                            $scope.isLoading = false;
                                            $mdDialog.hide();
                                            $scope.additionals['buttonDisabled'] = false;
                                        })
                                        .error(function (data) {
                                            $scope.isLoading = false;
                                            $scope.errors = data.errors;
                                            $scope.additionals['buttonDisabled'] = false;
                                            if (data == null) {
                                                $rootScope.checkNetworkConnection();
                                            }
                                        });
                            };

                        }
                    }
                };

                /* publish model */
                $scope.publishModel = function (ev, path, model, section) {

                    if ($scope.mode_action == 'page') {
                        $scope.controlSH = true;
                        $scope.action = 'publish';
                        $scope.errors = {};

                        $scope.additionals['invalid'] = '';
                        var currentModel = {};

                        angular.forEach(model, function (item, key) {
                            currentModel[key] = item;
                        });
                        $scope.modelData = currentModel;

                        $scope.cancel = function () {
                            $scope.modelData = {};
                            $scope.errors = {};
                            $scope.controlSH = false;
                        };

                        if (!angular.isUndefined($scope.additionals['function'])) {
                            $scope.additionals['function'](ev, $scope.modelData);
                        }

                        $scope.publish = function () {
                            $scope.additionals['buttonDisabled'] = true;
                            if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                $scope.additionals['internFunction'](ev, $scope.modelData);
                            }
                            $scope.isLoading = true;
                            $scope.modelData['route'] = 'publish';
                            Crud.post($scope.additionals['content_type'], $scope.modelData, path + '/publish')
                                    .success(function (data) {
                                        if (!angular.isUndefined(data.invalid)) {
                                            $scope.additionals['invalid'] = data.invalid;
                                        } else {
                                            $rootScope.initMenu();

                                            if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                $scope.additionals['functionResult'](ev, data);
                                            }
                                            if (!angular.isUndefined(data.currentModel)) {
                                                if (!angular.isUndefined($scope.models)) {
                                                    $scope.getElement($scope.models, data.currentModel);
                                                }
                                                if (!angular.isUndefined($scope.modelData)) {
                                                    $scope.modelData = data.currentModel;
                                                }
                                            } else {
                                                if (!angular.isUndefined($scope.models)) {
                                                    $scope.getElement($scope.models, currentModel);
                                                }
                                                if (!angular.isUndefined($scope.modelData)) {
                                                    $scope.modelData = currentModel;
                                                }
                                            }

                                        }
                                        $scope.modelData = {};
                                        $scope.errors = {};
                                        $scope.isLoading = false;
                                        $scope.controlSH = false;
                                        $scope.additionals['buttonDisabled'] = false;
                                    })
                                    .error(function (data) {
                                        $scope.isLoading = false;
                                        $scope.errors = data.errors;
                                        $scope.additionals['buttonDisabled'] = false;
                                        if (data == null) {
                                            $rootScope.checkNetworkConnection();
                                        }
                                    });
                        };
                    }
                    if ($scope.mode_action == 'dialog') {
                        $scope.additionals['invalid'] = '';
                        $scope.errors = {};
                        $scope.action = 'publish';
                        var currentModel = {};

                        angular.forEach(model, function (item, key) {
                            currentModel[key] = item;
                        });

                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'publishDialog.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {
                                pathTemplate: $scope.pathTemplate,
                                section: section,
                                model: currentModel,
                                selected: $scope.selected,
                                additionals: $scope.additionals,
                                action: $scope.action
                            }
                        }).then(function () {
                            if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                                if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                                    if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                                    }
                                    if (!angular.isUndefined($scope.modelData)) {
                                        $scope.modelData = $scope.additionals['dataCurrentModel'];
                                    }
                                } else {
                                    if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                                    }
                                    if (!angular.isUndefined($scope.modelData)) {
                                        $scope.modelData = currentModel;
                                    }
                                }

                            }
                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals', 'action'];
                        function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals, action) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.modelData = model;
                            $scope.additionals = additionals;
                            $scope.selected = selected;
                            $scope.section = section;
                            $scope.action = action;

                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                            if (!angular.isUndefined($scope.additionals['function'])) {
                                $scope.additionals['function'](ev, $scope.modelData);
                            }

                            $scope.publish = function () {
                                $scope.additionals['buttonDisabled'] = true;
                                if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                    $scope.additionals['internFunction'](ev, $scope.modelData);
                                }
                                $scope.isLoading = true;

                                $scope.modelData['route'] = 'publish';
                                Crud.post($scope.additionals['content_type'], $scope.modelData, path + '/publish')
                                        .success(function (data) {
                                            if (!angular.isUndefined(data.invalid)) {
                                                $scope.additionals['invalid'] = data.invalid;
                                            } else {
                                                $rootScope.initMenu();

                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                    $scope.additionals['functionResult'](ev, data);
                                                }
                                                /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                                 $scope.selected[model[$rootScope.typeId]] = model;
                                                 }*/
                                                if (!angular.isUndefined(data.currentModel)) {
                                                    $scope.additionals['dataCurrentModel'] = data.currentModel;
                                                    $scope.additionals['newDependentFields'] = data.newDependentFields;
                                                }

                                            }
                                            $scope.isLoading = false;
                                            $mdDialog.hide();
                                            $scope.additionals['buttonDisabled'] = false;
                                        })
                                        .error(function (data) {
                                            $scope.isLoading = false;
                                            $scope.errors = data.errors;
                                            $scope.additionals['buttonDisabled'] = false;
                                            if (data == null) {
                                                $rootScope.checkNetworkConnection();
                                            }
                                        });
                            };
                        }
                    }

                };

                /* show model */
                $scope.showModel = function (ev, path, model, key) {

                    /* key is index model */
                    if (!angular.isUndefined(key)) {
                        $scope.additionals['indexModel'] = key;
                    }
                    $scope.additionals['buttonDisabled'] = true;

                    if ($scope.mode_action == 'page') {
                        $scope.controlSH = true;
                        $scope.action = 'show';

                        if ($location.path() == '/slot') {
                            var positionAction = $('.class-action').position();
                            angular.element(document.querySelector('.fill-height')).animate({scrollTop: positionAction.top}, 'slow');
                        } else {
                            angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, 'slow');
                        }

                        $scope.modelData = {};
                        $scope.cancel = function () {
                            $scope.modelData = {};
                            $scope.errors = {};
                            $scope.controlSH = false;
                        };
                        if (!angular.isUndefined($scope.additionals['function'])) {
                            $scope.additionals['function'](ev, $scope.modelData);
                        }
                        Crud.show(model, path)
                                .success(function (data) {
                                    $scope.modelData = data;
                                    $scope.additionals['buttonDisabled'] = false;
                                    if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                        $scope.additionals['functionResult'](ev, data);
                                    }
                                });
                    }
                    if ($scope.mode_action == 'dialog') {
                        Crud.show(model, path)
                                .success(function (data) {
                                    $mdDialog.show({
                                        controller: DialogController,
                                        templateUrl: 'showDialog.tmpl.html',
                                        parent: angular.element(document.body),
                                        targetEvent: ev,
                                        clickOutsideToClose: true,
                                        locals: {
                                            pathTemplate: $scope.pathTemplate,
                                            model: data,
                                            formatText: $scope.formatText,
                                            formatDate: $scope.formatDate,
                                            columns: $scope.columns,
                                            additionals: $scope.additionals
                                        },
                                    });
                                    DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'formatText', 'formatDate', 'columns', 'additionals'];
                                    function DialogController($scope, $mdDialog, pathTemplate, model, formatText, formatDate, columns, additionals) {
                                        $scope.pathTemplate = pathTemplate;
                                        $scope.modelData = model;
                                        $scope.additionals = additionals;
                                        $scope.formatText = formatText;
                                        $scope.formatDate = formatDate;
                                        $scope.columns = columns;
                                        $scope.currency = $rootScope.currency;

                                        $scope.cancel = function () {
                                            $mdDialog.cancel();
                                        };
                                    }
                                    $scope.additionals['buttonDisabled'] = false;
                                }).error(function (data) {
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                            if (data == null) {
                                $rootScope.checkNetworkConnection();
                            }
                            if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                $scope.additionals['functionResult'](ev, data);
                            }
                        });
                    }
                };

                $scope.bindModel = function (ev, model) {
                    /*on enter*/
                    if (ev.keyCode == 13) {
                        $scope.editModel(ev, model);
                        //editModel($event, model)
                    }

                    /*on delete*/
                    if (ev.keyCode == 46) {
                        $scope.deleteModel(ev, model[$rootScope.typeId]);
                    }
                }

                /* delete model */
                $scope.deleteModel = function (ev, path, model) {
                    $scope.additionals['invalid'] = '';
                    $scope.modelData = {};
                    $mdDialog.show({
                        controller: DialogController,
                        templateUrl: 'deleteDialog.tmpl.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {pathTemplate: $scope.pathTemplate, model: model, additionals: $scope.additionals}
                    }).then(function (destroyModel) {

                        //if($scope.state.itemsPerPage == 0) {
                        var position = $scope.models.map(function (e) {
                            return e[$rootScope.typeId];
                        }).indexOf(parseInt(model[$rootScope.typeId]));
                        if (position >= 0) {
                            $scope.models.splice(position, 1);
                        }
                        //}

                        var no_pages = Math.ceil(($scope.total - 1) / $scope.state.itemsPerPage);
                        if (angular.isUndefined($scope.total)) {
                            var no_pages = $scope.models.current_page - 1;
                        }
                        if ($scope.state.page > no_pages) {
                            $scope.state.page = no_pages;
                        }

                        if ($scope.models.length <= 0) {
                            if ($scope.state.itemsPerPage != 0) {
                                $scope.getPaginateModel(path, $scope.state.page, $scope.state.itemsPerPage);
                            }
                        }
                    });

                    DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals'];
                    function DialogController($scope, $mdDialog, pathTemplate, model, additionals) {
                        $scope.pathTemplate = pathTemplate;
                        $scope.cancel = function () {
                            $mdDialog.cancel();
                        };
                        $scope.additionals = additionals;
                        $scope.modelData = model;

                        /* save a model */
                        $scope.destroyModel = function () {
                            $scope.additionals['buttonDisabled'] = true;
                            $scope.isLoading = true;
                            Crud.destroy(model.id, path)
                                    .success(function (data) {
                                        if (!angular.isUndefined(data.invalid)) {
                                            $scope.additionals['invalid'] = data.invalid;
                                        } else {
                                            if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                $scope.additionals['functionResult'](ev, data);
                                            }
                                        }
                                        $scope.isLoading = false;
                                        $mdDialog.hide();
                                        $scope.additionals['buttonDisabled'] = false;
                                    })
                                    .error(function (data) {
                                        $scope.errors = data.errors;
                                        $scope.isLoading = false;
                                        $scope.additionals['buttonDisabled'] = false;
                                        if (data == null) {
                                            $rootScope.checkNetworkConnection();
                                        }
                                    });
                        };
                    }
                };

                /* change status */
                $scope.changeStatus = function (ev, path, model, columns) {
                    $scope.additionals['buttonDisabled'] = true;
                    model.status = model.status == false ? 1 : 0;

                    Crud.changeStatus(model, path)
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                        $scope.additionals['functionResult'](ev, data);
                                    }
                                }
                                $scope.additionals['buttonDisabled'] = false;
                            });
                };

                /* duplicate a model */
                $scope.duplicateModel = function (ev, path, model) {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.additionals['invalid'] = '';
                    $scope.isLoading = true;
                    model['field'] = $scope.search['field'];
                    model['order'] = $scope.search['order'];
                    Crud.duplicate(model, path)
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                        $scope.additionals['functionResult'](ev, data);
                                    }
                                    if (!angular.isUndefined(data.position)) {
                                        var no_pages = Math.ceil((data.position + 1) / $scope.state.itemsPerPage);
                                    } else {
                                        var no_pages = Math.ceil(($scope.total + 1) / $scope.state.itemsPerPage);
                                    }
                                    if ($scope.state.itemsPerPage == 0) {
                                        if (!angular.isUndefined(data.position) && !angular.isUndefined(data.currentModel)) {
                                            $scope.models.splice(data.position, 0, data.currentModel);
                                        } else {
                                            $scope.getPaginateModel(path, no_pages, $scope.state.itemsPerPage);
                                        }
                                    }
                                    if ($scope.state.itemsPerPage != 0) {
                                        $scope.getPaginateModel(path, no_pages, $scope.state.itemsPerPage);
                                    }
                                }
                                $scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                                if (data == null) {
                                    $rootScope.checkNetworkConnection();
                                }
                            });
                };

                /* import model */
                $scope.importModel = function (ev, path) {
                    $scope.actionLabel = 'Import';
                        
                    if ($scope.mode_action == 'page') {
                        $scope.controlSH = true;
                        $scope.action = 'import';
                        $scope.errors = {};
                        $scope.additionals['invalid'] = '';

                        $scope.cancel = function () {
                            $scope.modelData = {};
                            $scope.errors = {};
                            $scope.controlSH = false;
                        };

                        $scope.import = function () {
                            $scope.additionals['buttonDisabled'] = true;
                            $scope.isLoading = true;
                            $scope.post = new FormData();
                            $scope.post.append('file', $scope.modelData['file']);
                            $scope.post.append('route', 'import');

                            Crud.import('undefined', $scope.post, $scope.path)
                                    .success(function (data) {
                                        if (!angular.isUndefined(data.invalid)) {
                                            $scope.additionals['invalid'] = data.invalid;
                                        }
                                        if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                            $scope.additionals['functionResult'](ev, data);
                                        }
                                        if (!angular.isUndefined(data.position)) {
                                            var no_pages = Math.ceil((data.position + 1) / $scope.state.itemsPerPage);
                                        } else {
                                            var no_pages = Math.ceil(($scope.total + 1) / $scope.state.itemsPerPage);
                                        }
                                        $scope.getPaginateModel(path, no_pages, $scope.state.itemsPerPage);

                                        if (!angular.isUndefined(data.newDependentFields)) {
                                            angular.forEach(data.newDependentFields, function (item, key) {
                                                if (item instanceof Array) {
                                                    angular.forEach(item, function (itemArray, keyArray) {
                                                        $scope.additionals[key].push(itemArray);
                                                    });
                                                } else {
                                                    $scope.additionals[key].push(item);
                                                }
                                            });
                                        }
                                        $scope.modelData = {};
                                        $scope.errors = {};
                                        $scope.isLoading = false;
                                        $scope.controlSH = false;
                                        $scope.additionals['buttonDisabled'] = false;
                                    })
                                    .error(function (data) {
                                        $scope.isLoading = false;
                                        $scope.errors = data.errors;
                                        $scope.additionals['buttonDisabled'] = false;
                                        if (data == null) {
                                            $rootScope.checkNetworkConnection();
                                        }
                                    });
                        }

                    }
                    if ($scope.mode_action == 'dialog') {
                        $scope.action = 'import';
                        $scope.errors = {};
                        $scope.additionals['invalid'] = '';
                        $scope.modelData = {};

                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'importDialog.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {model: $scope.modelData, pathTemplate: $scope.pathTemplate, additionals: $scope.additionals}
                        }).then(function () {
                            if (!angular.isUndefined($scope.additionals['position'])) {
                                var no_pages = Math.ceil(($scope.additionals['position'] + 1) / $scope.state.itemsPerPage);
                            } else {
                                var no_pages = Math.ceil(($scope.total + 1) / $scope.state.itemsPerPage);
                            }
                            $scope.getPaginateModel(path, no_pages, $scope.state.itemsPerPage);

                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'model', 'pathTemplate', 'additionals'];

                        function DialogController($scope, $mdDialog, model, pathTemplate, additionals) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.additionals = additionals;
                            $scope.modelData = model;

                            $scope.cancel = function () {
                                $scope.modelData = {};
                                $scope.errors = {};
                                $mdDialog.cancel();
                            };

                            $scope.import = function () {
                                $scope.additionals['buttonDisabled'] = true;
                                $scope.isLoading = true;
                                $scope.post = new FormData();
                                $scope.post.append('file', $scope.modelData['file']);
                                $scope.post.append('route', 'import');

                                Crud.import('undefined', $scope.post, path)
                                        .success(function (data) {
                                            if (!angular.isUndefined(data.invalid)) {
                                                $scope.additionals['invalid'] = data.invalid;
                                            } else {
                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                    $scope.additionals['functionResult'](ev, data);
                                                }
                                                if (!angular.isUndefined(data.position)) {
                                                    $scope.additionals['position'] = data.position;
                                                }
                                                if (!angular.isUndefined(data.newDependentFields)) {
                                                    angular.forEach(data.newDependentFields, function (item, key) {
                                                        if (item instanceof Array) {
                                                            angular.forEach(item, function (itemArray, keyArray) {
                                                                $scope.additionals[key].push(itemArray);
                                                            });
                                                        } else {
                                                            $scope.additionals[key].push(item);
                                                        }
                                                    });
                                                }

                                            }
                                            $scope.isLoading = false;
                                            $scope.errors = data.errors;
                                            $mdDialog.hide();
                                            $scope.additionals['buttonDisabled'] = false;
                                        })
                                        .error(function (data) {
                                            $scope.isLoading = false;
                                            $scope.errors = data.errors;
                                            $scope.additionals['buttonDisabled'] = false;
                                            if (data == null) {
                                                $rootScope.checkNetworkConnection();
                                            }
                                        });
                            }

                        }
                    }

                };

                $scope.selected = {};
                $scope.checkAll = function () {

                    if ($scope.selectedAll) {
                        $scope.selectedAll = true;
                    } else {
                        $scope.selectedAll = false;
                    }

                    angular.forEach($scope.models, function (item) {
                        item.selected = !$scope.selectedAll;
                        if (item.selected === true) {
                            $scope.selected[item[$rootScope.typeId]] = item;
                        }
                        if (item.selected === false) {
                            delete $scope.selected[item[$rootScope.typeId]];
                        }
                    });

                };
                $scope.checkIfTrue = function (item) {
                    var allTrue = [];
                    var no = 0;
                    angular.forEach($scope.models, function (itemu, keyu) {
                        if (itemu.selected === false || angular.isUndefined(itemu.selected)) {
                            allTrue[no] = keyu;
                            no++;
                        }
                    });

                    return allTrue;
                }
                $scope.checkItems = function (item) {
                    if (angular.isUndefined(item.selected)) {
                        item.selected = false;
                    }
                    if (item.selected === false) {
                        $scope.selected[item[$rootScope.typeId]] = item;
                    }
                    if (item.selected === true) {
                        delete $scope.selected[item[$rootScope.typeId]];
                    }

                    if ($scope.checkIfTrue(item).length == 1 && item.selected === false) {
                        $scope.selectedAll = true;
                    } else {
                        $scope.selectedAll = false;
                    }

                };

                /* delete multiple models */
                $scope.deleteMultipleModel = function (ev, path) {
                    $scope.additionals['invalid'] = '';
                    if ($scope.checkSelected($scope.selected, ev)) {
                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'deleteMultipleDialog.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {pathTemplate: $scope.pathTemplate, selected: $scope.selected, selectedAll: $scope.selectedAll, additionals: $scope.additionals}
                        }).then(function () {
                            if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {

                                //if($scope.state.itemsPerPage == 0) {
                                angular.forEach($scope.selected, function (item, index) {
                                    var position = $scope.models.map(function (e) {
                                        return e[$rootScope.typeId];
                                    }).indexOf(parseInt(index));
                                    if (position >= 0) {
                                        $scope.models.splice(position, 1);
                                    }
                                });
                                //}

                                var selectedArray = Object.keys($scope.selected);
                                if (!angular.isUndefined($scope.total)) {
                                    var no_pages = Math.ceil(($scope.total - selectedArray.length) / $scope.state.itemsPerPage);
                                } else {
                                    var no_pages = $scope.models.current_page - 1;
                                }
                                if ($scope.state.page > no_pages) {
                                    $scope.state.page = no_pages;
                                }

                                if ($scope.models.length <= 0) {
                                    if ($scope.state.itemsPerPage != 0) {
                                        $scope.getPaginateModel(path, $scope.state.page, $scope.state.itemsPerPage);

                                    }
                                }
                            }
                            $scope.selected = {};
                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'selected', 'selectedAll', 'additionals'];
                        function DialogController($scope, $mdDialog, pathTemplate, selected, selectedAll, additionals) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.additionals = additionals;
                            $scope.selected = selected;
                            $scope.selectedAll = selectedAll;

                            $scope.modelIds = {};
                            var no = 0;
                            angular.forEach($scope.selected, function (item, index) {
                                $scope.modelIds[index] = index;
                                no++;
                            });

                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                            $scope.destroyMultipleModel = function () {
                                $scope.additionals['buttonDisabled'] = true;
                                $scope.isLoading = true;
                                Crud.deleteMultiple($scope.modelIds, path)
                                        .success(function (data) {
                                            if (!angular.isUndefined(data.invalid)) {
                                                $scope.additionals['invalid'] = data.invalid;
                                            } else {
                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                    $scope.additionals['functionResult'](ev, data);
                                                }
                                            }
                                            $scope.selectedAll = false;
                                            $scope.selected = {};
                                            $scope.isLoading = false;
                                            $mdDialog.hide();
                                            $scope.additionals['buttonDisabled'] = false;
                                        }).error(function (data) {
                                    $scope.errors = data.errors;
                                    $scope.isLoading = false;
                                    $scope.additionals['buttonDisabled'] = false;
                                    if (data == null) {
                                        $rootScope.checkNetworkConnection();
                                    }
                                });
                            };
                        }
                    }
                };

                /* update multiple models */
                $scope.editMultipleModel = function (ev, path) {
                    $scope.action = 'updatemultiple';
                    if ($scope.mode_action == 'page') {
                        $scope.controlSH = true;
                        $scope.errors = {};
                        $scope.additionals['invalid'] = '';

                        if ($scope.checkSelected($scope.selected, ev) === true) {
                            var currentModels = {};
                            angular.forEach($scope.selected, function (items, index) {
                                currentModels[index] = {};
                                angular.forEach(items, function (item, key) {
                                    currentModels[index][key] = item;
                                });
                            });
                            $scope.modelsData = currentModels;

                            $scope.cancel = function () {
                                $scope.modelsData = {};
                                $scope.errors = {};
                                $scope.controlSH = false;

                                $scope.selectedAll = false;
                                angular.forEach($scope.selected, function (items, index) {
                                    items.selected = false;
                                    delete($scope.selected[index]);
                                });

                            };
                            if (!angular.isUndefined($scope.additionals['function'])) {
                                $scope.additionals['function'](ev, $scope.modelsData);
                            }

                            $scope.editMultiple = function () {
                                $scope.additionals['buttonDisabled'] = true;
                                if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                    $scope.additionals['internFunction'](ev, $scope.modelsData);
                                }
                                $scope.isLoading = true;
                                Crud.updateMultiple($scope.additionals['content_type'], $scope.modelsData, path)
                                        .success(function (data) {
                                            if (!angular.isUndefined(data.invalid)) {
                                                $scope.additionals['invalid'] = data.invalid;
                                            } else {
                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                    $scope.additionals['functionResult'](ev, data);
                                                }
                                                angular.forEach(currentModels, function (items, index) {
                                                    if (!angular.isUndefined(data.currentModels)) {
                                                        $scope.getElement($scope.models, data.currentModels[items['id']]);
                                                        currentModels[index] = data.currentModels[items['id']];
                                                    } else {
                                                        $scope.getElement($scope.models, items);
                                                        items.selected = false;
                                                    }
                                                    if (!angular.isUndefined(data.newDependentFields)) {
                                                        angular.forEach(data.newDependentFields, function (item, key) {
                                                            if (!angular.isUndefined(items['id'])) {
                                                                if (item instanceof Array) {
                                                                    angular.forEach(item, function (itemArray, keyArray) {
                                                                        $scope.additionals[key].push(itemArray[items['id']]);
                                                                    });
                                                                } else {
                                                                    $scope.additionals[key].push(item[items['id']]);
                                                                }
                                                            }
                                                        });
                                                    }
                                                });
                                            }
                                            $scope.isLoading = false;
                                            $scope.controlSH = false;
                                            $scope.selected = {};
                                            $scope.modelsData = {};
                                            $scope.selectedAll = false;
                                            $scope.errors = {};
                                            $scope.additionals['buttonDisabled'] = false;
                                        })
                                        .error(function (data) {
                                            $scope.errors = data.errors;
                                            $scope.isLoading = false;
                                            $scope.additionals['buttonDisabled'] = false;
                                            if (data == null) {
                                                $rootScope.checkNetworkConnection();
                                            }
                                        });
                            };
                        }
                    }
                    if ($scope.mode_action == 'dialog') {
                        $scope.errors = {};
                        $scope.additionals['invalid'] = '';
                        if ($scope.checkSelected($scope.selected, ev) === true) {
                            var currentModels = {};
                            angular.forEach($scope.selected, function (items, index) {
                                currentModels[index] = {};
                                angular.forEach(items, function (item, key) {
                                    currentModels[index][key] = item;
                                });
                            });

                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'editMultipleDialog.tmpl.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                                locals: {
                                    pathTemplate: $scope.pathTemplate,
                                    models: currentModels,
                                    additionals: $scope.additionals,
                                    selected: $scope.selected,
                                    selectedAll: $scope.selectedAll,
                                    action: $scope.action
                                }
                            }).then(function () {
                                if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                                    angular.forEach(currentModels, function (items, index) {
                                        if (!angular.isUndefined($scope.additionals['dataCurrentModels'])) {
                                            $scope.getElement($scope.models, $scope.additionals['dataCurrentModels'][items['id']]);
                                            currentModels[index] = $scope.additionals['dataCurrentModels'][items['id']];
                                        } else {
                                            $scope.getElement($scope.models, items);
                                        }
                                        items.selected = false;
                                        delete($scope.selected[index]);
                                    })
                                    $scope.selectedAll = false;
                                }
                            });
                            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'models', 'additionals', 'selected', 'selectedAll', 'action'];
                            function DialogController($scope, $mdDialog, pathTemplate, models, additionals, selected, selectedAll, action) {
                                $scope.pathTemplate = pathTemplate;
                                $scope.modelsData = models;
                                $scope.additionals = additionals;
                                $scope.selected = selected;
                                $scope.selectedAll = selectedAll;
                                $scope.action = action;

                                $scope.cancel = function () {
                                    $mdDialog.cancel();
                                    angular.forEach($scope.selected, function (items, index) {
                                        $scope.modelsData[index].selected = false;
                                        items.selected = false;
                                        delete($scope.selected[index]);
                                    });
                                    $scope.selectedAll = false;
                                };

                                if (!angular.isUndefined($scope.additionals['function'])) {
                                    $scope.additionals['function'](ev, $scope.modelsData);
                                }

                                $scope.editMultiple = function () {
                                    $scope.additionals['buttonDisabled'] = true;
                                    if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                        $scope.additionals['internFunction'](ev, $scope.modelsData);
                                    }
                                    $scope.isLoading = true;
                                    Crud.updateMultiple($scope.additionals['content_type'], models, path)
                                            .success(function (data) {
                                                if (!angular.isUndefined(data.invalid)) {
                                                    $scope.additionals['invalid'] = data.invalid;
                                                } else {
                                                    if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                        $scope.additionals['functionResult'](ev, data);
                                                    }

                                                    if (!angular.isUndefined(data.currentModels)) {
                                                        $scope.additionals['dataCurrentModels'] = data.currentModels;
                                                        $scope.additionals['newDependentFields'] = data.newDependentFields;
                                                    }

                                                }
                                                $scope.isLoading = false;
                                                $mdDialog.hide();
                                                $scope.errors = {};
                                                $scope.additionals['buttonDisabled'] = false;
                                            })
                                            .error(function (data) {
                                                $scope.errors = data.errors;
                                                $scope.isLoading = false;
                                                $scope.additionals['buttonDisabled'] = false;
                                                if (data == null) {
                                                    $rootScope.checkNetworkConnection();
                                                }
                                            });
                                };
                            }
                        }
                        $scope.selectedAll = false;
                    }
                };

                $scope.search = {};
                $scope.searchControl = false;
                $scope.searchModel = function (ev, path) {
                    $scope.searchControl = true;
                    $scope.getPaginateModel(path, 1, $scope.defaultItem);
                }

                $scope.removeDate = function () {
                    angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
                    angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
                }

                $scope.cancelSearch = function (ev, path) {
                    $scope.search = {};

                    if ($scope.searchControl == true) {
                        $scope.searchControl = false;
                        $scope.getPaginateModel(path, 1, $scope.defaultItem);
                    }
                    angular.element(document.querySelector('.expand-collapse-content')).slideToggle('200', function () {
                        angular.element(document.querySelector('#collapse i')).toggleClass('fa-minus fa-plus');
                    });
                    angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
                    angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
                    angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
                    angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
                    var form = document.getElementById('search-form');
                    form.reset();

                    $timeout($scope.removeDate, 500);

                }

                $scope.additionals['closeTimeSearch'] = function (ev, field) {
                    if (ev.keyCode == 46) {
                        if (field == 'timeTo') {
                            $scope.search.timeTo = undefined;
                        }
                        if (field == 'timeFrom') {
                            $scope.search.timeFrom = undefined;
                        }
                    }
                }

                $scope.getElement = function (array, element) {
                    if (!angular.isUndefined(element)) {
                        var position = array.map(function (e) {
                            return e[$rootScope.typeId];
                        }).indexOf(element[$rootScope.typeId]);
                        array[position] = element;
                    }
                }
                $scope.additionals['getElement'] = function (array, element) {
                    if (!angular.isUndefined(element)) {
                        var position = array.map(function (e) {
                            return e[$rootScope.typeId];
                        }).indexOf(element[$rootScope.typeId]);
                        array[position] = element;
                    }
                }

                $scope.isEmpty = function (obj) {
                    for (var prop in obj) {
                        if (obj.hasOwnProperty(prop))
                            return false;
                    }
                    return true;
                };

                $scope.checkSelected = function (obj, ev) {
                    if ($scope.isEmpty(obj)) {
                        $mdDialog.show(
                                $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title('Selecteaza randuri.')
                                .textContent('')
                                .ariaLabel('Selecteaza randuri')
                                .ok('Ok')
                                .targetEvent(ev)
                                );
                        return false;
                    }
                    return true;
                };

                $scope.parseInt = parseInt;
                $scope.additionals['associativeColumn'] = function (columns, id, secParam, type) {
                    if (!angular.isUndefined(columns)) {
                        if (!angular.isUndefined(columns.options)) {

                            var position = columns.options.map(function (e) {
                                if (!angular.isUndefined(type)) {
                                    return parseInt(e[$rootScope.typeId]);
                                } else {
                                    return e[$rootScope.typeId];
                                }
                            }).indexOf(id);

                            if (!angular.isUndefined(columns.options[position])) {
                                if (!angular.isUndefined(secParam) && secParam != null && secParam != 'null') {
                                    return columns.options[position][secParam];
                                } else {
                                    return columns.options[position].value;
                                }
                            }
                        }
                    }
                }

                $scope.additionals['compareDates'] = function (date1, date2) {
                    var datenew1 = new Date(date1).getTime();
                    var datenew2 = new Date(date2).getTime();

                    if (datenew1 >= datenew2) {
                        return true;
                    } else {
                        return false;
                    }
                }

                $scope.additionals['combineDateTime'] = function (date, time) {
                    var day = date.getDate();
                    if (day <= 9) {
                        var day = '0' + day;
                    }
                    var month = date.getMonth() + 1;
                    if (month <= 9) {
                        var month = '0' + month;
                    }
                    var year = date.getFullYear();
                    var hours = time.getHours();
                    if (hours <= 9) {
                        var hours = '0' + hours;
                    }
                    var minutes = time.getMinutes();
                    if (minutes <= 9) {
                        var minutes = '0' + minutes;
                    }
                    var seconds = time.getSeconds();
                    if (seconds <= 9) {
                        var seconds = '0' + seconds;
                    }
                    return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + 'Z';

                }

                $scope.close = function (columns, columnRelation, filters) {
                    if (!angular.isUndefined($scope[filters][columns])) {
                        delete $scope[filters][columns];
                    }

                    if (!angular.isUndefined(columnRelation)) {
                        if (!angular.isUndefined($scope[filters][columnRelation])) {
                            delete $scope[filters][columnRelation];
                        }
                    }
                }

                $scope.formatText = function (text) {
                    text = text.split('_').join(' ');
                    text = text.toLowerCase();
                    return text.charAt(0).toUpperCase() + text.slice(1);
                }

                $scope.formatDate = function (date) {
                    return moment(date).format('DD/MM/YYYY');
                }
                $scope.additionals['formaterDate'] = function (date, format) {
                    //return moment(date, 'DD-MM-YY').format(format);
                    return moment(date).format(format);
                }

                $scope.additionals['formatTime'] = function (time) {
                    return moment.utc(time * 1000).format('HH:mm:ss');
                }

                $scope.formatTextController = function (text) {
                    var result = text.replace(/([A-Z])/g, "-$1").toLowerCase();
                    return result.slice(1);
                }

                $scope.additionals['truncate'] = function (content, maxCharacters) {
                    if (content == null)
                        return '';

                    content = '' + content;
                    content = content.trim();

                    if (content.length <= maxCharacters)
                        return content;
                    content = content.substring(0, maxCharacters);

                    var lastSpace = content.lastIndexOf(' ');
                    if (lastSpace > -1)
                        content = content.substr(0, lastSpace);

                    return content + '...';

                };

                $scope.formatPrice = function (price, unit) {
                    return price + ' EUR/' + unit;
                }

                $scope.additionals['checkField'] = function (array, propId, prop, param) {
                    if (param !== null && !angular.isUndefined(param)) {
                        param = param.toLowerCase();

                        if (!angular.isUndefined(array)) {
                            var position = array.map(function (e) {
                                return e[prop].toLowerCase();
                            }).indexOf(param);

                            if (!angular.isUndefined(array[position])) {
                                return array[position][propId];
                            } else {
                                return false;
                            }
                        }
                    }
                }

                $scope.additionals['generateRange'] = function (start, stop) {
                    var array = [];
                    var length = stop - start;

                    for (var i = 0; i <= length; i++) {
                        array[i] = start;
                        start++;
                    }
                    return array;
                }

                $scope.formatDecimal = function (number) {
                    if (!angular.isUndefined(number)) {
                        return Number(number).toFixed(2);
                    }
                }

                $scope.additionals['formatDecimal'] = function (number) {
                    if (!angular.isUndefined(number)) {
                        return Number(number).toFixed(2);
                    }
                }

                $scope.additionals['convertToFloat'] = function (number) {
                    return parseFloat(number);
                }

                $scope.formatPercent = function (number) {
                    return number + '%';
                }

                $scope.additionals['formatTextResult'] = function (str) {
                    if (str != null) {
                        str = str.toLowerCase().replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function (replace_latter) {
                            return replace_latter.toUpperCase();
                        });  // /\b[a-z]/g

                        str = str.replace(/\s\s+/, ' ');
                    }
                    return str;
                }

                $scope.additionals['getBoolField'] = function (field)
                {
                    if (field == 1) {
                        field = true;
                    }
                    if (field == 0 || field === null) {
                        field = 'false';
                    }

                    return field;
                }

                $scope.additionals['convertToTime'] = function (seconds)
                {
                    var days = Math.floor(seconds / 86400);
                    var hours = Math.floor((seconds % 86400) / 3600);
                    var mins = Math.floor(((seconds % 86400) % 3600) / 60);
                    var secs = Math.floor(((seconds % 86400) % 3600) % 60);
                    var result = (days > 0 ? days + 'd ' : '') + ('00' + hours).slice(-2) + ':' + ('00' + mins).slice(-2) + ':' + ('00' + secs).slice(-2);
                    return result;
                }

                $scope.additionals['diffDates'] = function (start, end)
                {
                    var end = moment(end);
                    var duration = moment.duration(end.diff(start));
                    return moment.utc(duration.as('milliseconds')).format('HH : mm : ss');
                }

                $scope.additionals['diffDatesMinutes'] = function (start, end)
                {
                    var end = moment(end);
                    var duration = moment.duration(end.diff(start));
                    return parseInt(duration.as('minutes'));
                }

                $scope.additionals['groupArrayByProp'] = function (array, prop) {
                    let group = array.reduce((r, a) => {
                        r[a[prop]] = [...r[a[prop]] || [], a];
                        return r;
                    }, {});

                    return group;
                }
                
                $scope.additionals['sortByProp'] = function (models, prop) {
                       models.sort(function(a,b) {
                                  if (!a[prop] && b[prop])
                                    return 1;
                                  if (a[prop] && !b[prop])
                                    return -1;
                                });
                }
        

            }])
        .filter('sumByKey', function () {
            return function (data, key, keySec) {
              
                if (typeof (data) === 'undefined' || typeof (key) === 'undefined' || typeof (keySec) === 'undefined') {                      return 0;
                }
                var sum = 0;

                for (var i = data.length - 1; i >= 0; i--) { 
                    if (typeof (keySec) === 'undefined' || keySec == '') { 
                        if (typeof (data[i][key]) === 'undefined') {
                            data[i][key] = 0;
                        }
                        sum += parseFloat(data[i][key]);
                    } else {
                        if (typeof (data[i][key]) !== 'undefined') {
                            if (typeof (data[i][key][keySec]) === 'undefined') {
                                data[i][key][keySec] = 0;
                            }
                            sum += parseFloat(data[i][key][keySec]);
                        }
                    }
                    // console.log(sum.toFixed(2));
                    // sum = parseFloat(sum).toFixed(2);
                }

                if (key == 'calls_duration' || key == 'call_duration') {
                    var days = Math.floor(sum / 86400);
                    var hours = Math.floor((sum % 86400) / 3600);
                    var mins = Math.floor(((sum % 86400) % 3600) / 60);
                    var secs = Math.floor(((sum % 86400) % 3600) % 60);
                    var result = (days > 0 ? days + 'd ' : '') + ('00' + hours).slice(-2) + ':' + ('00' + mins).slice(-2) + ':' + ('00' + secs).slice(-2);

                    sum = result + ' (' + sum + ')';
                    return sum;

                } else if (key == 'calls_rate' || key == 'call_price') {
                    return sum.toFixed(2);
                } else {
                    return sum;
                }
            };
        })
        .filter('secondsToDateTime', [function () {
                return function (seconds) {
                    var days = Math.floor(seconds / 86400);
                    var hours = Math.floor((seconds % 86400) / 3600);
                    var mins = Math.floor(((seconds % 86400) % 3600) / 60);
                    var secs = Math.floor(((seconds % 86400) % 3600) % 60);
                    return (days > 0 ? days + 'd ' : '') + ('00' + hours).slice(-2) + ':' + ('00' + mins).slice(-2) + ':' + ('00' + secs).slice(-2);
                };
            }])
        .filter('avgByKey', [function () {
                return function (data, key) {
                    if (typeof (data) === 'undefined' || typeof (key) === 'undefined') {
                        return 0;
                    }
                    var avg = 0;
                    var sum = 0;
                    var no = 0;
                    for (var i = data.length - 1; i >= 0; i--) {
                        if (data[i][key] != null && data[i][key] != 'null') {
                            sum += parseFloat(data[i][key]);
                            no++;
                        }
                    }
                    avg = sum / no;
                    avg = avg.toFixed(2);
                    return avg;
                };
            }])
        .filter('avgTimeByKey', [function () {
                return function (data, key) {
                    if (typeof (data) === 'undefined' || typeof (key) === 'undefined') {
                        return 0;
                    }
                    var avg = 0;
                    var sum = 0;
                    if (data.length > 1) {
                        for (var i = data.length - 1; i >= 0; i--) {
                            if (data[i][key] != null && data[i][key] != 'null') {
                                sum += parseFloat(data[i][key]);
                            }
                        }
                        avg = sum / data.length; //in sec

                        var days = Math.floor(avg / 86400);
                        var hours = Math.floor((avg % 86400) / 3600);
                        var mins = Math.floor(((avg % 86400) % 3600) / 60);
                        var secs = Math.floor(((avg % 86400) % 3600) % 60);
                        return (days > 0 ? days + 'd ' : '') + ('00' + hours).slice(-2) + ':' + ('00' + mins).slice(-2) + ':' + ('00' + secs).slice(-2);
                    } else {
                        return '00:00:00';
                    }

                };
            }])
